export class ConstantService {
  allFeedback = [
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_186061330_511325989884007_7341087622705120423_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_189294582_3973372506042269_6702920387263244243_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_188633748_751553822194526_8916679812387452936_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_191388276_494573528447931_6231121982333374892_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_194210643_158954212874094_4217533816438450739_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_211517798_194010455992313_2286650529284867909_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/Viraat+99.8_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.00+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.05+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_175145242_818793249022175_6381061630965996921_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_178441433_108334691402384_3815796675965294369_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_185757235_370148547881685_767326053032517619_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_186061330_511325989884007_7341087622705120423_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_188210462_468067141084865_7211977758102126246_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/PHOTO-2021-11-24-11-10-40+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/Shubhashish+95_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2021-12-08+at+3.17.19+PM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.31.59+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.32.01+AM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.32.07+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/cat-online-coaching-3+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Gauravi+99.95_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/iquanta.in_217285748_1079262822605644_8257497034642892214_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/PHOTO-2021-11-24-11-10-43+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Satya+99.51_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Shalini+95.86_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Viraat+99.8_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2021-12-08+at+3.17.20+PM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2021-12-10+at+6.23.00+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.01+AM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.02+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.05+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_173588546_292446229167244_8376197896413654952_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_173730331_756852591683096_9032857273557690937_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174246276_768424443804941_52377484706623560_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174255383_603974190614215_2844271926068934979_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174359146_1041901229670986_8555334716098221729_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174611987_272180851249850_5351449715890524908_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174672134_908657663243851_1021892538790810625_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_181678395_307421720762142_1509490656340453500_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_187297497_304295994493257_8311124040814758063_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_187406950_115208864057242_6926625651772562509_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_202217658_124928893116698_6936199404702681822_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-23-16-37-41+3+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-24-11-10-41+2.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-38-45.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-42-59.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-43-34.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-44-39.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-45-03.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-48-17.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-58-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-59-26.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-01-31.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-09-14.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-10-16.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-12-28-07.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-12-28-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-11.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-13.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-16.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-20+2.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-20.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-42-21.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Ayush+99.77_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Biswanath+IIM+B.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Copy+of+iquanta.in_176989375_181881490381647_9160139295155989495_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Dhruv%2B99.31_ile.webp' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_172680087_454820355802001_469103404182610865_n+(2).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_179669886_1690248594696339_7550879588233652521_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_180023830_1449232998743148_711784555342997512_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_182830118_109693194613131_6721295150829962035_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_183758116_195817382383051_3090584363342103210_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_183869118_453150022454019_8148330303246998022_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184028314_491744352250054_3754561005391200955_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184110731_871863633755571_7184043910302721343_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184715565_527169475315734_5972387701812062247_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184886080_568894937407463_3835280433844240552_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_185319033_138295071624858_5191843797553919863_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_186876191_526333281699065_4035818877393527184_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_187515803_137234238447668_7728853287241391582_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_188103143_187813696429094_7412805334611555251_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_188136798_230366631757288_1099591734390206273_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_189546056_188739596448251_8434819666885250074_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_190938458_753696491966835_2419230105276682809_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_191343897_484705856086139_4834482054631241838_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_191792426_161176295894559_5458978941319900574_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_192705225_1702300829955842_6164118326083515077_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_192795983_322209939522199_716604903496274712_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194037289_2936014063335373_8731579729778686368_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194375248_966679697439438_5494561995608355492_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194741159_791952944858118_2287878546333851335_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194945955_1429166597443535_3851044893934660032_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_199009160_152795343541016_936407839720075605_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_213251156_515566116384053_2550478305482523155_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_217408919_529777981702962_6520123557787227492_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_218400480_352365116480816_5395901449286609854_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_243109894_567488487879601_6449389161724277030_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_244412581_579133256639290_3523767509282762050_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/PHOTO-2021-11-24-11-10-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/PHOTO-2021-11-24-11-10-42+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Ravi+99.2_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Sahibjeet+IIFT.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Shantanu+95.45ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.00+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.01+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.02+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.01+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.06+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' }
  ]
  doubtSolving: any[] = [
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_186061330_511325989884007_7341087622705120423_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_189294582_3973372506042269_6702920387263244243_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_188633748_751553822194526_8916679812387452936_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_191388276_494573528447931_6231121982333374892_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_194210643_158954212874094_4217533816438450739_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/iquanta.in_211517798_194010455992313_2286650529284867909_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/Viraat+99.8_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.00+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.05+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/24_7-Doubt-Solving/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' },
  ]
  heighScore: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_175145242_818793249022175_6381061630965996921_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_178441433_108334691402384_3815796675965294369_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_185757235_370148547881685_767326053032517619_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_186061330_511325989884007_7341087622705120423_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_188210462_468067141084865_7211977758102126246_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/iquanta.in_190781004_484934279394175_8324459811870473182_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/PHOTO-2021-11-24-11-10-40+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/Shubhashish+95_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2021-12-08+at+3.17.19+PM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.31.59+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.32.01+AM+(2).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Low-to-High-Score/WhatsApp+Image+2023-02-03+at+10.32.07+AM.jpeg' }
  ]
  peerToPeer: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/cat-online-coaching-3+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Gauravi+99.95_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/iquanta.in_217285748_1079262822605644_8257497034642892214_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/PHOTO-2021-11-24-11-10-43+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Satya+99.51_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Shalini+95.86_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/Viraat+99.8_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2021-12-08+at+3.17.20+PM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2021-12-10+at+6.23.00+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.01+AM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.02+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.05+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Peer-To-Peer-Learning/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' }
  ]
  contentRelavency: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_173588546_292446229167244_8376197896413654952_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_173730331_756852591683096_9032857273557690937_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174246276_768424443804941_52377484706623560_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174255383_603974190614215_2844271926068934979_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174359146_1041901229670986_8555334716098221729_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174611987_272180851249850_5351449715890524908_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_174672134_908657663243851_1021892538790810625_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_181678395_307421720762142_1509490656340453500_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_187297497_304295994493257_8311124040814758063_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_187406950_115208864057242_6926625651772562509_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/iquanta.in_202217658_124928893116698_6936199404702681822_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-23-16-37-41+3+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-24-11-10-41+2.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-38-45.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-42-59.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-43-34.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-44-39.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-45-03.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-48-17.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-58-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-14-59-26.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-01-31.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-09-14.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-11-29-15-10-16.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-12-28-07.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-12-28-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-11.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-13.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-16.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-20+2.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-38-20.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Content-Relevancy/PHOTO-2021-12-05-14-42-21.jpg' }

  ]
  dualPedagogy: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Ayush+99.77_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Biswanath+IIM+B.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Copy+of+iquanta.in_176989375_181881490381647_9160139295155989495_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Dhruv%2B99.31_ile.webp' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_172680087_454820355802001_469103404182610865_n+(2).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_179669886_1690248594696339_7550879588233652521_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_180023830_1449232998743148_711784555342997512_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_182830118_109693194613131_6721295150829962035_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_183758116_195817382383051_3090584363342103210_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_183869118_453150022454019_8148330303246998022_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184028314_491744352250054_3754561005391200955_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184110731_871863633755571_7184043910302721343_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184715565_527169475315734_5972387701812062247_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_184886080_568894937407463_3835280433844240552_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_185319033_138295071624858_5191843797553919863_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_186876191_526333281699065_4035818877393527184_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_187515803_137234238447668_7728853287241391582_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_188103143_187813696429094_7412805334611555251_n+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_188136798_230366631757288_1099591734390206273_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_189546056_188739596448251_8434819666885250074_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_190938458_753696491966835_2419230105276682809_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_191343897_484705856086139_4834482054631241838_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_191792426_161176295894559_5458978941319900574_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_192705225_1702300829955842_6164118326083515077_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_192795983_322209939522199_716604903496274712_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194037289_2936014063335373_8731579729778686368_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194375248_966679697439438_5494561995608355492_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194741159_791952944858118_2287878546333851335_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_194945955_1429166597443535_3851044893934660032_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_199009160_152795343541016_936407839720075605_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_213251156_515566116384053_2550478305482523155_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_217408919_529777981702962_6520123557787227492_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_218400480_352365116480816_5395901449286609854_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_243109894_567488487879601_6449389161724277030_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/iquanta.in_244412581_579133256639290_3523767509282762050_n.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/PHOTO-2021-11-24-11-10-38.jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/PHOTO-2021-11-24-11-10-42+(1).jpg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Ravi+99.2_ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Sahibjeet+IIFT.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/Shantanu+95.45ile.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.00+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.01+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2021-12-10+at+6.23.02+PM+(1).jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.01+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.06+AM.jpeg' },
    { img: 'https://media.iquanta.in/ui_images/Dual-Pedagogy/WhatsApp+Image+2023-02-03+at+10.32.06+AM+(2).jpeg' }
  ]



  menus: any[] = [
    {
      name: 'What is the eligibility for applying to the undergraduate programs of University of Delhi?',
      iconClass: 'fa fa-code',
      active: true,
      submenu: [
        { answer: 'You should have passed class 12 (or its equivalent) or should be appearing for class 12 (or its equivalent) examination in 2022. There is NO minimum percentage that you need to have.', subanswers: [] },
      ]
    },
    {
      name: 'Do my class 12 marks have any weight in my admission to an undergraduate program in University of Delhi? ',
      iconClass: 'fa fa-mobile',
      active: false,
      submenu: [
        { answer: 'No. Your admission in University of Delhi is based ONLY on your performance in the CUET 2022. ', subanswers: [] },
      ]
    },
    {
      name: 'Is gap year a problem in taking admission in an undergraduate program of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Not at all. Gap year does NOT put you at any disadvantage as far as your admission in an undergraduate program of University of Delhi is concerned. You do NOT even need to submit any certificate in this regard.', subanswers: [] },
      ]
    },
    {
      name: 'What are the age limits for taking admission in an undergraduate program of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: "There is NO such age limit (lower or upper).", subanswers: [] },
      ]
    },
    {
      name: 'I have NOT studied History at class 12 level. Can I apply for B.A. (Hons.) History in University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, it will not be a problem at all. If you have studied science/commerce subjects at class 12 level, you may apply to any course in Arts. For taking admission in B.A. (Hons.) Economics, you must have studied Mathematics at class 12 level.', subanswers: [] },
      ]
    },
    {
      name: 'Do I need to apply to different colleges of University of Delhi for taking admission in an undergraduate program?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'No. You just need to indicate programs of your choice in the CUET 2022 application.', subanswers: [] },
      ]
    },
    {
      name: 'Is there any disadvantage to me in the admission in an undergraduate program of University of Delhi if I switch from science (at class 12 level) to arts/commerce at undergraduate level?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Not at all.', subanswers: [] },
      ]
    },
    {
      name: 'Do I need to come to Delhi for the centralized counseling for undergraduate admissions in University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'No. It will be e-counseling. You will have to come to Delhi/New Delhi to attend classes!', subanswers: [] },
      ]
    },
    {
      name: 'Is there any reservation in University of Delhi for seats in its undergraduate programs?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, University of Delhi follows the rules made by the Government of India and it has reservations for', subanswers: [] },
        { answer: 'Scheduled Castes (SC): 15% ', subanswers: [] },
        { answer: 'Scheduled Tribe (ST): 7.5%', subanswers: [] },
        { answer: 'Other Backward Castes Non-Creamy (OBC-NC): 27% ', subanswers: [] },
        { answer: 'Economically Weaker Section (EWS): 10%.', subanswers: [] },
        { answer: 'Other than this the university has some colleges run by some minority ', subanswers: [] },
        { answer: '(Christian/Sikh) institutions (St. Stephen’s College, Jesus and Mary College, SGTB ', subanswers: [] },
        { answer: 'Khalsa College, Mata Sundari College, etc.) that have flat 50% reservation for the minority that runs the institution.', subanswers: [] },
      ]
    },
    {
      name: 'Is it mandatory to take CUET 2022 for taking admission in undergraduate programs of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes. There are two exceptions to this: School of Open Learning (SOL) and Non-Collegiate Women Education Board (NCWEB). Admissions to the SOL and the NCWEB will be based on marks in class 12. If you are a foreigner (to India), then also the CUET is not mandatory for you.', subanswers: [] },
      ]
    },
    {
      name: 'Do I need to put the preference for colleges in University of Delhi while applying for the CUET 2022?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'No, you CANNOT opt for colleges in the CUET application. You can only opt for the programs and the universities. You CANNOT give any preference for the universities either. Please bear in mind that the order, in which you put the programs/universities in the CUET application, does NOT matter at all.', subanswers: [] },
      ]
    },
    {
      name: 'Can I opt for a Domain-Specific Subject test in CUET 2022 if I did not have that particular subject in class 12 (for applying to an undergraduate program of University of Delhi)?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'No. As far as University of Delhi is concerned, you can opt for ONLY those subjects in Section 2 (Domain-Specific Subject) of the CUET that you have/had in class 12. However, it obviously does not apply to the General Test (section 3 of the CUET) or the Language Tests (section 1 of the CUET).', subanswers: [] },
      ]
    },
    {
      name: 'I am weak at English; how difficult would it be for me to take admission in an undergraduate program of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'There are ONLY two undergraduate courses (out of a total of 74) offered by University of Delhi that expect you to take a Language Test in English: B.A. (Hons.) English and B.A. (Hons.) Journalism. If you are weak at English, please opt for a medium (for Domain-Specific Subject tests and General Test) other than English. You have as many as 12 choices (other than English) for the medium: Assamese, Bengali, Gujarati, Hindi, Kannada, Malayalam, Marathi, Odia, Punjabi, Tamil, Telugu and Urdu. Also, you may appear for a Language Test other than English and you have as many as 32 choices for it!', subanswers: [] },
      ]
    },
    {
      name: 'Is taking a Language Test (Section 1 of the CUET) compulsory for taking admission in an undergraduate program of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes. There are courses for which your score in the Language Test is just qualifying (you need to score 30% i.e. 60 out of 200) and this will not be added to your total. There are some other courses for which your score in the Language Test will be added to the total.', subanswers: [] },
      ]
    },
    {
      name: 'Is taking the General Test (Section 3 of the CUET) compulsory for taking admission in an undergraduate program of University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'There are ONLY 6 courses for which the General Test is compulsory:', subanswers: [] },
        { answer: 'A. 5-year Integrated Program in Journalism', subanswers: [] },
        { answer: 'B. B.A. (Hons.) Multimedia and Mass Communication', subanswers: [] },
        { answer: 'C. B.Tech. (Information Technology and Mathematical Innovation) ', subanswers: [] },
        { answer: 'D. Bachelor of Management Studies (BMS)', subanswers: [] },
        { answer: 'E. Bachelor of Business Administration (Financial Investment Analysis)', subanswers: [] },
        { answer: 'F. B.A (Hons.) Business Economics', subanswers: [] },
        { answer: 'There are courses for which the General Test is optional i.e. it is part of one of the many combinations of tests offered to you (with at least one combination without the General Test).', subanswers: [] },
      ]
    },
    {
      name: 'I have arts/commerce in class 12, am I eligible for B.Sc. (Hons.) Mathematics from University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, provided Mathematics was one of your papers in class 12. In fact, there are many other courses in science in which you can take admission despite being from arts/commerce background provided mathematics was one of your ', subanswers: [] },
        { answer: 'papers in Class 12. Some of these courses are:', subanswers: [] },
        { answer: 'B.Sc. (Hons.) Computer Science', subanswers: [] },
        { answer: 'B.Sc. (Hons.) Statistics ', subanswers: [] },
        { answer: 'B.Sc. (Prog.) Mathematical Sciences.', subanswers: [] },
      ]
    },
    {
      name: 'I did not have Mathematics in class 12, can I apply for B.Com. (Hons.) at University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, provided you had Accountancy in class 12. It is compulsory to have at least one of Mathematics and Accountancy in class 12 to be eligible for B.Com (Hons.) from University of Delhi. However, you are eligible for B.Com (without Hons.) even if you did not have any of Mathematics and Accountancy in class 12. There are as many as 44 colleges in University of Delhi that offer B.Com.', subanswers: [] },
      ]
    },
    {
      name: 'Does University of Delhi offer 5-year B.A. LL.B. or B.B.A. LL.B.?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'No. University of Delhi offers a 3-year LL.B., but this course is only for graduates.', subanswers: [] },
      ]
    },
    {
      name: 'Does University of Delhi offer B. El. Ed. (Bachelor of Elementary Education)?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes, there are 8 colleges in University of Delhi that offer B. El. Ed. All these 8 colleges are ONLY for women. You are not eligible for this course if you are a boy!', subanswers: [] },
      ]
    },
    {
      name: 'Is B.A. (Hons.) Psychology available for boys in University of Delhi?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'A. Aryabhatta College', subanswers: [] },
        { answer: 'B. Keshav Mahavidyalaya', subanswers: [] },
        { answer: 'C. Zakir Hussain Delhi College', subanswers: [] },
      ]
    },
    {
      name: 'Does University of Delhi offer courses in Journalism at undergraduate level?',
      iconClass: 'fa fa-globe',
      active: false,
      submenu: [
        { answer: 'Yes. These are the courses offered by the university on Journalism:', subanswers: [] },
        { answer: 'A. 5-year Integrated Program in Journalism', subanswers: [] },
        { answer: 'B. B.A. (Hons.) in Multimedia and Mass Communication', subanswers: [] },
        { answer: 'C. B.A. (Hons.) Journalism (this is for journalism in English)', subanswers: [] },
        { answer: 'D. B.A. (Hons.) Hindi Patrakarita (this is for journalism in Hindi)', subanswers: [] },
      ]
    },
  ];
  reviews: any[] = [
    {
      img: 'https://media.iquanta.in/ui_images/reviews/devyani.png', title: 'Devyani Mengi',
      percentage: 'Political Science-100 | Psychology-100 | English-98.09 | Economics-97.9',
      text: 'I would like to acknowledge your efforts and hardwork that helps me score good in CUET exam.',
      long_description: 'Dear IQuanta, I would like to acknowledge your efforts and hardwork that helps me score good in CUET exam. I am very happy that my family and my decision of choosing IQuanta as a study platform to prepare for CUET exam was right. I am happy with my score in the exam. I would like to extend my gratitude towards teachers who helped me in preparing and solving all my doubts. At the end,  I would like to say that IQuanta is the perfect place to prepare for competitive exams. Thank you'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/shivansh.png', title: 'Shivansh Tiwari',
      percentage: 'English - 100 percentile',
      text: 'I completely relied on the study material, questionnaires & mocks provided by iQuanta.',
      long_description: 'I completely relied on the study material, questionnaires & mocks provided by iQuanta. It helped me perform excellent in English & General test. Faculties were very friendly and supportive to clarify doubts whenever needed. I extend my sincere thanks.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/muskan.png', title: 'Muskan',
      percentage: 'English - 97.68 Percentile',
      text: 'Mock tests by iQuanta helped me manage time and formulate a strategy to crack the exam.',
      long_description: 'Mock tests by iQuanta helped me manage time and formulate a strategy to crack the exam. I recommend mocks to everyone as they are available as sectionals as well as assignments. I am thankful to the faculties who were always motivating us to perform better and better.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/jyoti.png', title: 'Jyoti Garg',
      percentage: 'English - 95.26 ',
      text: 'The study material was relevant and concise. Mocks helped me to improve upon ',
      long_description: 'The study material was relevant and concise. Mocks helped me to improve upon my mistakes and not commit the same in the actual exam. Joining iQuanta was indeed the best decision towards cracking CUET.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/sunitha.png', title: 'Sunita Chitale',
      percentage: 'Accountancy - 95+ | Business Studies - 95+ | Economics - 96+',
      text: 'I Can safely say that one should choose iQuanta for their CUET Preparation. All my doubts whether academic or non ',
      long_description: 'I Can safely say that one should choose iQuanta for their CUET Preparation. All my doubts whether academic or non academic related to course and colleges were also quickly addressed. Thankyou iQuanta for instilling such a great confidence in me.     '
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/dhruv.png', title: 'Dhruv Sethi',
      percentage: 'English - 99.5 | Mathematics - 98.9 | General Test - 99.5',
      text: 'Right from well curated mocks to extensive doubt clarification, there was nothing that iQuanta left in my journey. ',
      long_description: 'Right from well curated mocks to extensive doubt clarification, there was nothing that iQuanta left in my journey. Faculties personally motivated me at time when I needed it the most. I am bereft of words to thank Faculties and mentors. '
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/divyanshi.png', title: 'Divyanshi Tevatia',
      percentage: 'Mathematics - 95.47',
      text: 'I don’t know what I would’ve done without iQuanta classes and mocks. All the mentors kept',
      long_description: 'I don’t know what I would’ve done without iQuanta classes and mocks. All the mentors kept me motivated and on top of my content. They always made sure they give their best.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/tizil.png', title: 'Tizil Chaturvedi',
      percentage: 'Accountancy- 96.4 | Business Studies - 97.2',
      text: 'iQuanta facilitated my preparation in every possible way. I recommend everyone to ',
      long_description: 'iQuanta facilitated my preparation in every possible way. I recommend everyone to take the mocks seriously and learn from their mistakes. The same helped me. All the faculties made sure that our bases were clear.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/riya.png', title: 'Riya ',
      percentage: 'English - 97.4',
      text: 'All the video lectures and practice tests were a click away and I never felt that I had to manage board',
      long_description: 'All the video lectures and practice tests were a click away and I never felt that I had to manage board exams alongside CUET. The syllabus and material were to the point and properly curated. I always felt happy to write and mocks and kept making me perform better everyday.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/garv.png', title: 'Garv Chokhani ',
      percentage: 'English - 97.2 | General test - 99.06',
      text: 'Starting early with iQuanta was the key to my success. I took the exam very seriously as it was being',
      long_description: 'Starting early with iQuanta was the key to my success. I took the exam very seriously as it was being conducted for the first time, I had many doubts and confusions regarding colleges, courses, Study material and all of them were clarified by mentors who were almost 24*7 available.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/ritik.png', title: 'Ritik Anjna',
      percentage: 'English - 99.55 | Accountancy - 94.27',
      text: 'CUET as a completely new exam with new set of rules and regulations made me nervous in the beginning but',
      long_description: 'CUET as a completely new exam with new set of rules and regulations made me nervous in the beginning but that nervousness disappeared in no time after I joined iQuanta and personally talked to the mentors about it. They very patiently explained every question I asked them. I highly recommend iQuanta to every student, especially the average ones like me. '
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/sahil.png', title: 'Sahil Makker ',
      percentage: 'English - 100 | Economics - 98.67',
      text: 'I could not believe my eyes when I got a 100 percentile in English. I instantly thanked my mentors and teachers',
      long_description: 'I could not believe my eyes when I got a 100 percentile in English. I instantly thanked my mentors and teachers for being fantastic, always approachable. They always pushed me to believe that the target was achievable. I recommend iQuanta Mocks and Test series to every student and properly analyse your mistakes. Thankyou iQuanta for helping me achieve this accolade.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/harsh.png', title: 'Harsh Sharma ',
      percentage: 'Business Studies - 99.55 | Economics - 96.7',
      text: 'Mock tests and study material complemented with on time mentorship helped me a lot',
      long_description: 'Mock tests and study material complemented with on time mentorship helped me a lot. I constantly bothered faculties and mentors not only for doubts but for counselling related queries which were very politely addressed. I pay my sincere gratitude to iQuanta. Thankyou.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/meera.png', title: 'Meera',
      percentage: 'Accountancy- 98.7 | General Test- 97.3 | Business Studies- 95',
      text: 'iQuanta classes were the best thing that happened to me. I will undoubtedly recommend',
      long_description: 'iQuanta classes were the best thing that happened to me. I will undoubtedly recommend mocks and classes to everyone who aspires to get into the top colleges. Mentors are very friendly and full of knowledge. I could always watch the recorded classes whenever I missed them which helped me cover up whenever I used to lag behind.Thankyou iQuanta for always encouraging me.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/falak.png', title: 'Falak Zehra',
      percentage: 'Accountancy -91 | Economics-91',
      text: 'I was very confused since the very first time I heard of the term CUET. With so many changes and combination',
      long_description: 'I was very confused since the very first time I heard of the term CUET. With so many changes and combination of subjects to choose from, I always feared committing silly mistakes. I don’t remember any instance when I needed the mentors and they were not there. This is a genuine feedback that I am writing here to thank all the faculties genuinely for instilling a strong belief in me.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/palak.png', title: 'Palak Pandey',
      percentage: 'Accountacy-98.4 | Business Studies-97.8 | General Test-95.3',
      text: 'I want to thank all the faculties and mentors at iQuanta for curating mocks and tests very close to the actual exam. ',
      long_description: 'I want to thank all the faculties and mentors at iQuanta for curating mocks and tests very close to the actual exam. All the mentors were ever ready to help and motivate me. General Test never felt like a new subject to me since a wide variety of questions were properly covered by faculties. '
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/parul.png', title: 'Parul Singh',
      percentage: 'General Test-98.08 | Business Studies-97.5 | Economics-96.8',
      text: 'I will never be able to thank all the teachers enough for having made test prep so easy.',
      long_description: 'I will never be able to thank all the teachers enough for having made test prep so easy. CUET being the first competitive exam that I was going to write, I wanted to come up with flying colours and I believe I have. My confidence was boosted from my performance in the test series and increasing mock scores.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/harshit.png', title: 'Harshit Aggarwal',
      percentage: 'English - 97.4',
      text: 'I joined iQuanta for my English Language preparation and I am more than happy with my performance. ',
      long_description: 'I joined iQuanta for my English Language preparation and I am more than happy with my performance. This would not have been possible without the constant support of all the faculties who not only taught us but always motivated us as well.'
    },
    {
      img: 'https://media.iquanta.in/ui_images/reviews/darshika.png', title: 'Darshika Gupta',
      percentage: 'General Test-99.6 | Accountancy-99.06 | Mathematics-96.3',
      text: 'I would like to give credits to iQuanta faculties and mentors for all their support and encouragement.',
      long_description: 'I would like to give credits to iQuanta faculties and mentors for all their support and encouragement. There were ups and downs during the test prep and mock performances but the collective effort from Teachers through the last few crucial months helped me a lot.'
    }

  ]
  membersList: any[] = [
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory1.png',
      name: 'Gursimran Ahuja,  IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.83',
      story: 'Being active in your online CAT course and learning from other students’ doubts or approach can help you avoid mistakes and enable you to solve questions faster  , and I have iQuanta to thank for providing me that platform from where I could amplify my achievements in the given amount of time to a great extent',
      link: 'https://www.iquanta.in/blog/cat-tips-by-gursimran-ahuja-iim-abc-convert/',
      percent: '99.83',
      title: 'CAT Percentile',
      titlename:'Gursimran Ahuja',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory2.webp',
      name: 'Shikhar Sachdeva , IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.98',
      story: "How can I even begin to thank the mentor Indrajeet Singh, who was there at each step of the journey to guide me, and to show me the right direction. It's been a wonderful journey so far. Hope it ends in the best possible manner.",
      link: 'https://www.iquanta.in/blog/my-journey-to-success-topping-cat-exam/',
        percent: '99.98',
      title: 'CAT Percentile',
        titlename:'Shikhar Sachdeva',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory3.webp',
      name: 'Sahil Aggarwal, IIM Ahmedabad',
      subtext: 'CAT Percentile : 99.76',
      story: "As there were time limitations to prepare along with the job I decided to rely on iQuanta course for quant. My quant showed significant improvement and was fortunate to score 99.76 percentile in CAT 17 and 99.67 percentile in XAT 18.Message for Indrajeet sir: Personally I found this to be the best material for quant preparation for CAT which ideally suited my preparation style. Thank you for the course sir, keep helping and motivating the students coming through.",
      link: 'https://www.iquanta.in/blog/story-of-an-iim-abc-convert-an-iquanta-student/',
        percent: '99.76',
      title: 'CAT Percentile',
        titlename:'Sahil Aggarwal',
      college: 'IIM Ahmedabad'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory4.webp',
      name: 'Biswanath Chakraborty, IIM Bangalore',
      subtext: 'CAT Percentile : 99.06',
      story: "The journey started with cat preparation 2 years back , with me practising with stalwarts here of the previous batch. It has been an amazing journey with iQuanta .The immense pool of knowledge that this group shares is exemplary. Indrajeet sirjee you have been an inspiration , with constant tutelage you gave us just the right impetus. Alas vastrapur was not meant to be but thankfully I could crack IIM B. For the upcoming cat , I would say just stay focused, practice hard and remember sky is the limit. Thank you everyone ,will miss you .",
      link: 'https://www.iquanta.in/blog/converted-iim-bangalore-as-a-fresher-bursting-the-myth-biswanath-chakraborty/',
        percent: '99.06',
      title: 'CAT Percentile',
        titlename:'Biswanath Chakraborty',
      college: 'IIM Bangalore'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory5.png',
      name: 'Debarshee Mitra , IIM Calcutta',
      subtext: 'CAT Percentile : 99.70',
      story: "Thank you so much Indrajeet. I still remember in September when I was still solving arun sharma and realized that I couldn't solve half the questions posted on the group that I decided to join iquanta. Ended up with 99.86 in quant(should have been more). Every topic being revised more than I did even for my 10th boards and the results are there for all to see. Thank you again, it has been a pleasure.",
      link: 'https://www.iquanta.in/blog/success-story-of-debashree-mitra-iim-calcutta-convert/',
        percent: '99.70',
      title: 'CAT Percentile',
        titlename:'Debarshee Mitra',
      college: 'IIM Calcutta'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory6.png',
      name: 'Akshat Jain, IIM Bangalore',
      subtext: 'CAT Percentile : 99.82',
      story: "I think that Indrajeet’s shortcuts and tricks are very useful and come handy during the exam. From personal experience, I think there were 2-3 questions of Quantitative Aptitude which were pretty direct and could be solved using just his formulas.",
      link: 'https://www.iquanta.in/blog/the-cat-success-story-of-akshat/',
        percent: '99.82',
      title: 'CAT Percentile',
        titlename:'Akshat Jain',
      college: 'IIM Bangalore'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory7.png',
      name: 'Pratik Ranjan',
      subtext: 'IIM Lucknow',
      story: "I think Indrajeet sir is doing a great job with the amazing tips and shortcuts. I joined the crash course provided by iQuanta which helped me with a quick revision of everything and it helped me to a great extent.",
      link: 'https://www.iquanta.in/blog/preparation-strategy-of-iim-l-convert-prateek-ranjan/',
        percent: '99.83',
      title: 'IIM Lucknow',
        titlename:'Pratik Ranjan',
      college: 'IIM Lucknow'
    },
    {
      img: 'https://media.iquanta.in/ui_images/successstory8.webp',
      name: 'Shweta Arya',
      subtext: 'IIM Shillong',
      story: "I think iQuanta CAT online coaching is a pre-requisite to nail any management exam. It helped me strengthen my weaker sections and also improve my scores in my stronger sections.",
      link: 'https://www.iquanta.in/blog/cat-story-shweta-arya-calls-iift-sibm-p-nmims-iim-s-tiss/',
         percent: '99.83',
      title: 'IIM Shillong',
        titlename:'Shweta Arya',
      college: 'IIM Shillong'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory9.png',
      name: 'Arpit Behl ',
      subtext: 'MDI, Gurgaon ',
      story: "iQuanta played a leading role in my success. With the help of Indrajeet Sir in Quant- my stronger section, I scored a sectional score of 98.79%ile in Quant. I was not scoring in this section before. His shortcuts and methodology are excellent.",
      link: 'https://www.iquanta.in/blog/arpit-behl-how-iquanta-helped-me-ace-cat/',
         percent: '98.9',
      title: 'MDI, Gurgaon ',
        titlename:'Arpit Behl',
      college: 'MDI, Gurgaon'
    },
    {
      img: 'https://media.iquanta.in/ui_images/public_portal_img/successstory10.png',
      name: 'Shubham Varshney',
      subtext: 'IIM Ahmedabad',
      story: "When offline coaching ditched us, then iQuanta’s CAT online classes came to the rescue. Thanks a lot Indrajeet!",
      link: '',
       percent: '99.83',
      title: 'IIM Ahmedabad',
        titlename:'Shubham Varshney',
      college: 'IIM Ahmedabad'
    }

  ]
  rankers2023: any[] = [
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Guru.jpeg', name: 'Guru Charan', persentage: 'CAT 99.99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/pixelup+5.jpg', name: 'Manav Jain', persentage: 'CAT 99.99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Prikshit+tomer.jpeg', name: 'Parikshit Tomar', persentage: 'CAT 99.99%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/satyajitdas-670faf752a4fb.webp', name: 'Satyajit Das', persentage: 'CAT 99.97%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/swadesh+rath.jpeg', name: 'Swadesh Rath', persentage: 'CAT 99.97%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Aditya+singh.jpeg', name: 'Aditya Singh', persentage: 'CAT 99.95%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/sourabhdeep-66e94dbeba245.webp', name: 'Souradeep Banerjee', persentage: 'CAT 99.95%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Soumbhra+mukher+jee.jpeg', name: 'Soumbhra mukher jee', persentage: 'CAT 99.94%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/rahul+dandwate.jpeg', name: 'Rahul dandwate', persentage: 'CAT 99.92%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Umesh chandra', persentage: 'CAT 99.91%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Dhruv jajoo', persentage: 'CAT 99.91%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/nikhildhing-6710a0e4d35fe.webp', name: 'Nikhil dhing', persentage: 'CAT 99.9%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/rounaktikmani-670fac2e0af7d.webp', name: 'Rounak Tikmani', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Garg', persentage: 'CAT 99.9%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/venugoudamargani-66e94d8215ac4.webp', name: 'Venu Goud Amargani', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shivam singh', persentage: 'CAT 99.9%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jai Rawal', persentage: 'CAT 99.88%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Archit aggarwal', persentage: 'CAT 99.88%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/diwakar(1).jpeg', name: 'Diwakar singh tanwar', persentage: 'CAT 99.87%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/ritvikmanglik-66e94d800b3f3.webp', name: 'Ritvik Manglik', persentage: 'CAT 99.87%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mayukh+roy.jpeg', name: 'Mayukh Roy', persentage: 'CAT 99.87%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/nupur+kokate.jpeg', name: 'Nupur Kokate', persentage: 'CAT 99.86%ile' },
    { img: 'https://www.iquanta.in/blog/wp-content/uploads/2024/10/abhishekmishra-6710a04e0b976.webp', name: 'Abhishek mishra', persentage: 'CAT 99.85%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Rishav+banerjee.jpeg', name: 'RishavBanerjee', persentage: 'CAT 99.83%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pratyush Singh', persentage: 'CAT 99.83%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/bhavya+shah.jpeg', name: 'Bhavya Shah', persentage: 'CAT 99.82%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mehul+jain.jpg', name: 'Mehul jain', persentage: 'CAT 99.82%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Nayana+nair.jpeg', name: 'Nayana Nair', persentage: 'CAT 99.8%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'AVIK DAS', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Kashish', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/yash+kabra.jpeg', name: 'Yash kabra', persentage: 'CAT 99.78%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/shrishti+varshney.png', name: 'Shristi Varshney', persentage: 'CAT 99.76%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/vivek+goyal.jpeg', name: 'VIVEK GOYAL', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/swapna+neil+paul.jpeg', name: 'Swapna Neil Paul', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashutosh Aggarwal', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/krishna.png', name: 'Krishna Jaisansaria', persentage: 'CAT 99.75%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Deepanshu Mittal', persentage: 'CAT 99.74%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'vishesh gupta', persentage: 'CAT 99.74%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Advik Jain', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/paluk+shukla.png', name: 'Paluk Shukla', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Utkarsh+gupta.jpg', name: 'Utkarsh Gupta', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aditya Sehgal', persentage: 'CAT 99.73%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/G+Sreekara+Reddy.jpg', name: 'G Sreekara Reddy', persentage: 'CAT 99.69%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Vidya+datta.jpeg', name: 'Vidya Datta Vivek K', persentage: 'CAT 99.68%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Avinash Herle', persentage: 'CAT 99.66%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Divyanshu Garg', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Varsha Rai', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nandha', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ishan jalan', persentage: 'CAT 99.6%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shubham+rastogi.jpeg', name: 'Shubham Rustagi', persentage: 'CAT 99.57%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/mohita.jpg', name: 'Mohita Carmen K', persentage: 'CAT 99.57%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/om+srivastav.jpeg', name: 'OM Srivastav', persentage: 'CAT 99.53%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shuvam+Debnath.jpeg', name: 'Suvam Debnath', persentage: 'CAT 99.52%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Archisman+gupta.png', name: 'Archisman gupta', persentage: 'CAT 99.51%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Riman+bortharpur.jpg', name: 'Riman Borthakur', persentage: 'CAT 99.45%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Simran+Gupta.jpeg', name: 'Simran Gupta', persentage: 'CAT 99.45%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'yashvir brar', persentage: 'CAT 99.4%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'divyansh', persentage: 'CAT 99.4%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhishek deskhmukh', persentage: 'CAT 99.37%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shreyas+Panda.jpeg', name: 'Shreyas Panda', persentage: 'CAT 99.34%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nairirti', persentage: 'CAT 99.34%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Naman Sauparia', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Shreekeerthana.jpeg', name: 'Shreekeerthana', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Tanush+Biju.png', name: 'Tanush Biju', persentage: 'CAT 99.32%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/aravintakshan.png', name: 'Aravintakshan', persentage: 'CAT 99.31%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/tejaswini.png', name: 'Tejaswini', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Saumya', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Roopal Singh', persentage: 'CAT 99.3%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sayan.png', name: 'Sayan KumarMaity', persentage: 'CAT 99.29%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ria', persentage: 'CAT 99.28%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nandini Jain', persentage: 'CAT 99.26%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/suchit+arora.jpg', name: 'Suchit Arora', persentage: 'CAT 99.25%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/mahima+Sharma.png', name: 'Mahima Sharma', persentage: 'CAT 99.25%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sarvesh Shahshidhar', persentage: 'CAT 99.23%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sahil+shetty+j.jpg', name: 'Sahil Shetty', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sarthak.png', name: 'Sarthak Sathapathy', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Priyan Sood', persentage: 'CAT 99.21%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Tanish.jpg', name: 'Tanish', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sree sarath chandra', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/pragdeesh.jpeg', name: 'Pragdeesh', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Noel John', persentage: 'CAT 99.2%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/sushant.jpg', name: 'Sushant Elbhor', persentage: 'CAT 99.19%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/aditya+bose.jpg', name: 'Aditya bose', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rahul Palit', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/shen+shaji.jpg', name: 'Shen Shaji', persentage: 'CAT 99.16%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Sagnik+Dutta.jpg', name: 'Sagnik Dutta', persentage: 'CAT 99.15%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Divyansh+Sharma.jpg', name: 'Divyansh Sharma', persentage: 'CAT 99.14%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Avyay+Varma.png', name: 'Avyay Varma', persentage: 'CAT 99.13%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jatin Dialani', persentage: 'CAT 99.13%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Rishi+Kant.jpg', name: 'Rishi Kant', persentage: 'CAT 99.12%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Jytri+Veeramachaneni.jpg', name: 'Jytri Veeramachaneni', persentage: 'CAT 99.11%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tanuk Mittal', persentage: 'CAT 99.11%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Arunva+Chakraborty+.jpg', name: 'Arunva Chakraborty', persentage: 'CAT 99.08%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Ritwik+Jha.jpg', name: 'Ritwik Jha', persentage: 'CAT 99.08%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Gaurav Vicky', persentage: 'CAT 99.06%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashwin V Venkatesh', persentage: 'CAT 99.03%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shanay Shah', persentage: 'CAT 99.01%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Mohith+Kamatam.jpg', name: 'Mohith kamatam', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhishek Mangal', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Krishna Jaisansaria', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Ashrai+Paul.png', name: 'Ashrai paul', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/Durga.jpg', name: 'Durga', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'nikunj', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Vidyanshu shekhar', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Manu Aggarwal', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/CAT2023/payal+pradhan.png', name: 'Payal Pradhan', persentage: 'CAT 99%ile' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Esha jain', persentage: 'CAT 99%ile' },

  ]

  rankers2024: any[] = [
    {
        "name": "Shubh Karman Singh",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kanav",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mridul Tiwari",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vedant Chandewar",
        "persentage": "CAT 99.98",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Himanshu Singh Yadav",
        "persentage": "CAT 99.97",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Swaraj Pal",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prakhar Mundra",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harshul Ranadive",
        "persentage": "CAT 99.95",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush",
        "persentage": "CAT 99.93",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aman Ehtesham",
        "persentage": "CAT 99.93",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sanvie Singhal",
        "persentage": "CAT 99.92",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "MANU AGARWAL",
        "persentage": "CAT 99.91",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manan Maheshwari",
        "persentage": "CAT 99.91",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Mohta",
        "persentage": "CAT 99.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shivalik",
        "persentage": "CAT 99.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aniruddh",
        "persentage": "CAT 99.89",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Divyansh Agarwal",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "abhinav sudhini",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sanjeev Chitturi",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manvendra Singh",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Tara G.",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Souhardya Das",
        "persentage": "CAT 99.86",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Ram k",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "MANGALAM SHARMA",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Nikhilesh Vetcha",
        "persentage": "CAT 99.85",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Apoorv Swami",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Amritash Bharadwaj",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Eshaan",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anamay Ghate",
        "persentage": "CAT 99.84",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anindya Chatterjee",
        "persentage": "CAT 99.8",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shiladitya Bhadra",
        "persentage": "CAT 99.8",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Satwik Acharya",
        "persentage": "CAT 99.79",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Saksham",
        "persentage": "CAT 99.79",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Devbrat",
        "persentage": "CAT 99.78",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Seth",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vidyanshu Shekhar",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Atishay Mariya",
        "persentage": "CAT 99.76",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "KANISK",
        "persentage": "CAT 99.75",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Pradeepkumar Puchala",
        "persentage": "CAT 99.75",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rakshith S",
        "persentage": "CAT 99.73",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rishab Verma",
        "persentage": "CAT 99.73",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Krishna",
        "persentage": "CAT 99.72",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Neerav Chilkoti",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Gupta",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kavya Garg",
        "persentage": "CAT 99.71",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kartikey Gupta",
        "persentage": "CAT 99.7",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anuj Anil Kapse",
        "persentage": "CAT 99.7",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dhruv Mittal",
        "persentage": "CAT 99.69",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rounak tikmani",
        "persentage": "CAT 99.69",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Khushpreet Singh",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shreetama Sahu",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anushka",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "sudarshan duvvuru",
        "persentage": "CAT 99.68",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rajeev N",
        "persentage": "CAT 99.67",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Prasad Sahu",
        "persentage": "CAT 99.66",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Darsh Raju Mehta",
        "persentage": "CAT 99.66",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Raghvendra Pratap Singh",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Risheek Arora",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shinjan Patra",
        "persentage": "CAT 99.65",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Varun",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dhruv Bhattacharya",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kirti Pandey",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhinav jha",
        "persentage": "CAT 99.63",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "George",
        "persentage": "CAT 99.61",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Arjun Gupta",
        "persentage": "CAT 99.61",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Nitika Shroff",
        "persentage": "CAT 99.6",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Muskan Gupta",
        "persentage": "CAT 99.58",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mansi",
        "persentage": "CAT 99.58",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Gaurav Kumar",
        "persentage": "CAT 99.57",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Yashi Agrawal",
        "persentage": "CAT 99.57",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Gupta - Akshat ka bhai",
        "persentage": "CAT 99.56",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush Vats",
        "persentage": "CAT 99.55",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shambo Sinha",
        "persentage": "CAT 99.55",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rinku Aggarwal",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sania",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Saini",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Parth",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aabhas Kumar",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shaivi Goyal",
        "persentage": "CAT 99.54",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhagavathi Ravikrishnan",
        "persentage": "CAT 99.52",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sagnik Dutta",
        "persentage": "CAT 99.5",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Om Singh",
        "persentage": "CAT 99.49",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sounak Poddar",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Hriddhima Saha",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Arushi Khare",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dev Dhanani",
        "persentage": "CAT 99.48",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anindya Chatterjee",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rahul Sinha",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhyudaya Gupta",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vaibhav",
        "persentage": "CAT 99.47",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Maurya Pitti",
        "persentage": "CAT 99.44",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shouvik Chatterjee",
        "persentage": "CAT 99.43",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhaanu Ashok",
        "persentage": "CAT 99.43",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Siddhant Kumar",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Yash Jain",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Ritika Mathur",
        "persentage": "CAT 99.42",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Jagpreet Singh",
        "persentage": "CAT 99.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshat Toolaj Sinha",
        "persentage": "CAT 99.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aditya Goel - Multiple people availale",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harsh Gajpalla",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhijeet",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kartik Malhotra",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Souradeep Banerjee",
        "persentage": "CAT 99.39",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Harsh Deshpande",
        "persentage": "CAT 99.38",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sarthak Garg",
        "persentage": "CAT 99.38",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "rahulrai65",
        "persentage": "CAT 99.37",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Madhav Varshney",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "osman baig",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Bhavya Bajaj",
        "persentage": "CAT 99.36",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Akshay Krishnan R",
        "persentage": "CAT 99.35",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shantanu Goyal",
        "persentage": "CAT 99.35",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vaibhav Rajoriya",
        "persentage": "CAT 99.34",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhishek Kumar",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Amrinderpreet Singh",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Sridama Singh",
        "persentage": "CAT 99.33",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aanant Agarwal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Siddhartha Pal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Shivank Verma",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Karan Agrawal",
        "persentage": "CAT 99.31",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Manas Naik",
        "persentage": "CAT 99.3",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Karsheet Negi",
        "persentage": "CAT 99.29",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aman Goel",
        "persentage": "CAT 99.28",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mohit Kumar",
        "persentage": "CAT 99.28",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mithu Singh Rawat - Check",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Lakshay Panwar",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Gariman Gupta",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Suvam Debnath",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "ABHAY SINGH - Multiple ID",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Annu Joseph",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Chitwan Manchanda",
        "persentage": "CAT 99.26",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prakhar Pragya",
        "persentage": "CAT 99.24",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kislay Kashyap",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Varun S. Roshan",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhishek Jha",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Lamba",
        "persentage": "CAT 99.2",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kushagra Nath",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "aabhas kumar",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "sajja vasavi vasavi",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aparna Panicker",
        "persentage": "CAT 99.18",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anand Shukla",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Niteesh",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rohit Mehta",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Mihir Kumar",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Dipanwita Ch",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abhi",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Rajat Pattu",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vanshaj Aggarwal",
        "persentage": "CAT 99.16",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kshitij Hegde",
        "persentage": "CAT 99.13",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aayush Gandhi",
        "persentage": "CAT 99.12",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Priyanshu S",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Safi Ur Rahman",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Jagannadh",
        "persentage": "CAT 99.11",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Aaryaman Dadwal",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Kishlay Kinjal",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Vishesh Madaan",
        "persentage": "CAT 99.1",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anurag Kedia",
        "persentage": "CAT 99.09",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anamay Srivastava",
        "persentage": "CAT 99.07",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Anika Singh",
        "persentage": "98.9",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Atheenthara Ram S",
        "persentage": "97",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Abantika Karmakar",
        "persentage": "95.01",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    },
    {
        "name": "Prajwal V Sangam",
        "persentage": "91.4",
        "img": "https://media.iquanta.in/ui_images/cat2016/jake-small.jpg"
    }
]

  rankers2020: any[] = [
    { img: 'https://media.iquanta.in/ui_images/Shivam-Kumar.webp', name: 'Shivam Kumar', persentage: 'CAT Percentile: 99.95' },
    { img: 'https://media.iquanta.in/ui_images/Rahul-Agrawal.webp', name: 'Rahul Agrawal', persentage: 'CAT Percentile: 99.92' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sabyasachi-Mishra-small.jpg', name: 'Sabyasachi Mishra', persentage: 'CAT Percentile: 99.90' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dibyendu-Patra.jpg', name: 'Dibyendu Patra', persentage: 'CAT Percentile: 99.85' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Bitanesh-Bhattacharya.jpg', name: 'Bitanesh Bhattacharya', persentage: 'CAT Percentile: 99.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Mayank.jpg', name: 'Mayank', persentage: 'CAT Percentile: 99.76' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Priyanka-Reddy.jpg', name: 'Priyanka Reddy', persentage: 'CAT Percentile: 99.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pranjal-Chaudhary.jpg', name: 'Pranjal Chaudhary', persentage: 'CAT Percentile: 99.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Heenal-Raghvani.jpg', name: 'Heenal Raghvani', persentage: 'CAT Percentile: 99.63' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rishabh-Jain.jpg', name: 'Rishabh Jain', persentage: 'CAT Percentile : 99.62' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Karan-Dutta.jpg', name: 'Karan Dutta', persentage: 'CAT Percentile:  99.56' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rahul-Arora.jpg', name: 'Rahul Arora', persentage: 'CAT Percentile: 99.56' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Indranil-Mukherjee.jpg', name: 'Indranil Mukherjee', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Mustafa-Haider.jpg', name: 'Mustafa Haider', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Prateek-Ayush.jpg', name: 'Prateek Ayush', persentage: 'CAT Percentile : 99.53' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Nikhil-Birajdar.jpg', name: 'Nikhil Birajdar', persentage: 'CAT Percentile: 99.48' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pragyay-Parashar.jpg', name: 'Pragyay Parashar', persentage: 'CAT Percentile: 99.47' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Reuben Mathew', persentage: 'CAT Percentile: 99.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhinav-Pali.jpg', name: 'Abhinav Pali', persentage: 'CAT Percentile: 99.45' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Saransh-Mohanty.jpg', name: 'Saransh Mohanty', persentage: 'CAT Percentile: 99.43' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhishek-Anshu.jpg', name: 'Abhishek Anshu', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sapnil-Bhoi.jpg', name: 'Sapnil Bhoi ', persentage: 'CAT Percentile: 99.33 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Purbita-Seal.jpg', name: 'Purbita Seal', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sourabh-Singh.jpg', name: 'Sourabh Singh', persentage: 'CAT Percentile: 99.28' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Akshat-Gupta.jpg', name: 'Akshat Gupta', persentage: 'CAT Percentile: 99.23' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Syed-Abdus-Sattar.jpg', name: 'Syed Abdus Sattar', persentage: 'CAT Percentile: 99.2 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Utkarsh-Joshi.jpg', name: 'Utkarsh Joshi', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Piyush-Aras.jpg', name: 'Piyush Aras', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ankit-Guleria.jpg', name: 'Ankit Guleria', persentage: 'CAT Percentile: 99.2' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Abhinay-Shrivastav.jpg', name: 'Abhinay Shrivastav', persentage: 'CAT Percentile: 99.11' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ritwik-Tiwari.jpg', name: 'Ritwik Tiwari', persentage: 'CAT Percentile: 99.09' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ankit-Sagu.jpg', name: 'Ankit Sagu', persentage: 'CAT Percentile: 99.02' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tarunsree Kata', persentage: 'CAT Percentile : 99.09' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Bharghvi-Prajapati.jpg', name: 'Bharghvi Prajapati', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Ananya-Chaudhary.jpg', name: 'Ananya Chaudhary', persentage: 'CAT Percentile: 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Harshit-Jain.jpg', name: 'Harshit Jain', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Amber Jain', persentage: 'CAT Percentile : 99' },
    { img: 'https://media.iquanta.in/ui_images/Ankit-Raj.webp', name: 'Ankit Raj', persentage: 'CAT Percentile:  99.96' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Syed-Abdus-Khattar.jpg', name: 'Syed Abdus Khattar ', persentage: 'From 74%le to 99.2%le' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Yasser-Khan.jpg', name: 'Yasser Khan', persentage: 'From 21%le to around 90%le' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Anusha-Harikumar.jpg', name: 'Anusha Harikumar', persentage: 'From 68%le to 94.1%le' },
    { img: 'https://media.iquanta.in/ui_images/Ruhi-Singh.webp', name: 'Ruhi Singh', persentage: '99.9 in Quants' },

    { img: 'https://media.iquanta.in/ui_images/cat2020/Govind-Sivan-S.jpg', name: 'Govind Sivan S', persentage: '99.6 in LRDI ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sai-Srikar-Velichety.jpg', name: 'Sai Srikar Velichety', persentage: '99.64 in LRDI ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Harsh-Bhargava.jpg', name: 'Harsh Bhargava', persentage: 'CAT Percentile: 98.84 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sharique-Ahmad.jpg', name: 'Sharique Ahmad', persentage: 'CAT Percentile : 98.82' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Chirag-Kumar.jpg', name: 'Chirag Kumar', persentage: 'CAT Percentile : 98.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Saurav-Surwade.jpg', name: 'Saurav Surwade', persentage: 'CAT Percentile:  98.78' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Amit-Shete.jpg', name: 'Amit Shete', persentage: 'CAT Percentile:  98.69 ' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Neharika-Jain.jpg', name: 'Neharika Jain', persentage: 'CAT Percentile:  98.65' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dibyendu-Bhadra.jpg', name: 'Dibyendu Bhadra', persentage: 'CAT Percentile:  98.6' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Dhruv-Luthra.jpg', name: 'Dhruv Luthra', persentage: 'CAT Percentile:  98.52' },

    { img: 'https://media.iquanta.in/ui_images/cat2020/Anurag-Kumar.jpg', name: 'Anurag Kumar', persentage: 'CAT Percentile:  98.5' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Sumeet-Yadav.jpg', name: 'Sumeet Yadav', persentage: 'CAT Percentile:  98.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Rupesh-Gupta.jpg', name: 'Rupesh Gupta', persentage: 'CAT Percentile: 98.3' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Pranjal-Gupta.jpg', name: 'Pranjal Gupta', persentage: 'CAT Percentile : 98.14' },
    { img: 'https://media.iquanta.in/ui_images/cat2020/Aashita-Jain.jpg', name: 'Aashita Jain', persentage: 'CAT Percentile : 98.06' }
  ]
  rankers2018: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2018/mihir.webp', name: 'Mihir Kapse', persentage: 'CAT Percentile: 99.97' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ananta.jpg', name: 'Ananta Chhajer', persentage: 'CAT Percentile: 99.91' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/utkarsh.jpg', name: 'Utkarsh Bajpai', persentage: 'CAT Percentile: 99.87' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aabhas.jpg', name: 'Aabhas Mathur', persentage: 'CAT Percentile: 99.86' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/tushar.jpg', name: 'Tushar Singhal', persentage: 'CAT Percentile: 99.70' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/anurag.jpg', name: 'Anurag Shukla', persentage: 'CAT Percentile: 99.70' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/amar.jpg', name: 'Amar Agrahari', persentage: 'CAT Percentile: 99.67' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/rishabh.jpg', name: 'Rishabh Vijay', persentage: 'CAT Percentile: 99.66' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/kunal.jpg', name: 'Kunal Jain', persentage: 'CAT Percentile: 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shuvendu.jpg', name: 'Shuvendu Jha', persentage: 'CAT Percentile : 99.54' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/vineet.jpg', name: 'Vineet Bajaj', persentage: 'CAT Percentile:  99.53' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aditya.jpg', name: 'Aditya Prasad', persentage: 'CAT Percentile: 99.51' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shibashis.jpg', name: 'Shibashis Ganguly', persentage: 'CAT Percentile: 99.51' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/jay.jpg', name: 'Jay Patel', persentage: 'CAT Percentile: 99.46' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/manavdeep.jpg', name: 'Manavdeep Singh', persentage: 'CAT Percentile : 99.40' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/hari.jpg', name: 'Hari Haran', persentage: 'CAT Percentile: 99.39' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/charchil.jpg', name: 'Charchil Jain', persentage: 'CAT Percentile: 99.38' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/jatin.jpg', name: 'Jatin Singla', persentage: 'CAT Percentile: 99.33' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/divey.jpg', name: 'Divey Jot', persentage: 'CAT Percentile: 99.30' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shivam.jpg', name: 'Shivam Khandelwal', persentage: 'CAT Percentile: 99.17' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/bhrigu.jpg', name: 'Bhrigu Chopra', persentage: 'CAT Percentile: 99.16' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/priyanshu.jpg', name: 'Priyanshu Porwal ', persentage: 'CAT Percentile: 99.10' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sahib.jpg', name: 'Sahib Chawla', persentage: 'CAT Percentile: 99.07' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sagar.jpg', name: 'Sagar Tavse', persentage: 'CAT Percentile: 99.06' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shailesh Mehta', persentage: 'CAT Percentile: 99.03' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Ashish Khetan Potus', persentage: 'CAT Percentile: 99.00' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ayush1.jpg', name: 'Aayush Agarwal', persentage: 'From 93 to 99.69 Qa' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sugandha.jpg', name: 'Sugandha Jain ', persentage: 'From 83 to 98 Qa' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/richa.jpg', name: 'Richa Kenkre', persentage: '52 to 92 QA' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/adarsh.jpg', name: 'Adarsh Jaiswal', persentage: '75 to 93 QA' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/Janmejay.jpg', name: 'Janmejay Singh Hada', persentage: '99.86 (QA)' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/Harsh.jpg', name: 'Harsh Wardhan ', persentage: 'CAT Percentile: 98.88' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/ronit.jpg', name: 'Ronit Ray', persentage: 'CAT Percentile : 98.81' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/abhishek.jpg', name: 'Abhishek purab das ', persentage: 'CAT Percentile : 98.86' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/aayush.jpg', name: 'Aayush Agarwal', persentage: 'CAT Percentile: 98.63' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/durga.jpg', name: 'Durga Madhab', persentage: 'CAT Percentile : 98.60' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shivambansal.jpg', name: 'Shivam Bansal', persentage: 'CAT Percentile : 98.66' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/shubham.jpg', name: 'Shubham Gupta', persentage: 'CAT Percentile:  98.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/rahul.jpg', name: 'Rahul Jeswani ', persentage: 'CAT Percentile : 98.41' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/sriharsha.jpg', name: 'Sri Harsha', persentage: 'CAT Percentile : 97.5' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/akshata.jpg', name: 'Akshata Masoor', persentage: 'CAT Percentile: 98.7' },
    { img: 'https://media.iquanta.in/ui_images/cat2018/younus.jpg', name: 'Younus Waquar', persentage: 'from mere 39% to near 90 %le' },
  ]
  rankers2019: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2019/rishi.webp', name: 'Rishi Mittal', persentage: 'CAT: 100 %ler' },
    { img: 'https://media.iquanta.in/ui_images/kislay.webp', name: 'Kislay Jha', persentage: 'CAT : 99.96 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/deb.jpg', name: 'Deb Singhdeo', persentage: 'CAT : 99.89 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/Romik.jpg', name: 'Romik Banerjee', persentage: 'CAT : 99.87 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/akhil.jpg', name: 'Akhil Bhutada', persentage: 'CAT : 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/bitanesh.jpg', name: 'Bitanesh Bhattacharya ', persentage: 'CAT : 99.66 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/devesh.jpg', name: 'Devesh Bansal', persentage: 'CAT : 99.65 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/yash.jpg', name: 'Yash Jain', persentage: 'CAT : 99.57 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/karthikgupta.jpg', name: 'Kartik Gupta', persentage: 'CAT : 99.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shubham.jpg', name: 'Shubham Sharma', persentage: 'CAT : 99.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Raghav Rathore', persentage: 'CAT :  99.49%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/avinash.jpg', name: 'Avinash Singh', persentage: 'CAT : 99.48 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/suman.jpg', name: 'Suman Gande ', persentage: 'CAT:  99.43 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shobhit.jpg', name: 'Shobhit Datta', persentage: 'CAT: 99.40 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/vaibhav.jpg', name: 'Vaibhav Gupta', persentage: 'CAT:  99.38 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/nihal.jpg', name: 'Nihal Singh', persentage: 'CAT : 99.31 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Risab Agnihotri', persentage: 'CAT : 99.25 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/czaee.jpg', name: 'Czaee Shefali Kolekar', persentage: 'CAT : 99.1 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/karal.jpg', name: 'Karal Maheshwari', persentage: 'CAT : 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/rishabh.jpg', name: 'Rishabh Dwived', persentage: 'CAT :~99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/harsha.jpg', name: 'Harsha Surapaneni', persentage: 'CAT : 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/arshia.jpg', name: 'Arshia Sethi ', persentage: 'CAT : 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/ankur.jpg', name: 'Ankur Agarwal', persentage: 'CAT :  99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/dhruv.jpg', name: 'Dhruv Dua', persentage: 'CAT :  99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Harsh Patel', persentage: 'CAT : 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shivansh.jpg', name: 'Shivansh Agarwal', persentage: 'CAT  : ~99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/palak.jpg', name: 'Palak Aneja', persentage: 'CAT : ~ 99%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/Prachet.jpg', name: 'Prachet Prakash', persentage: 'CAT :  98.81%ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/manan.jpg', name: 'Manan Dhar', persentage: 'CAT :  98.8 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/ayush.jpg', name: 'Ayush Jhingala', persentage: 'CAT : 98.6 %ler' },
    // {img: 'https://media.iquanta.in/ui_images/cat2019/abhishek.jpg', name: 'Abhishek Smarty', persentage: 'CAT : 99.79 %ler'},
    // {img: 'https://media.iquanta.in/ui_images/cat2019/ankit.jpg', name: 'Ankit Desai', persentage: 'CAT : 99.91 %ler'},
    { img: 'https://media.iquanta.in/ui_images/cat2019/riyank.jpg', name: 'Riyank Roy', persentage: 'CAT : 98.6 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/biswarup.jpg', name: 'Biswarup Ghosh', persentage: 'CAT : 98.03 %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shivam.jpg', name: 'Shivam Bansal', persentage: 'CAT  : 98.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Abhinav Pruthi ', persentage: 'CAT  : 98.81 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Faisal khan', persentage: 'CAT  : 98.54 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/yugank.jpg', name: 'Yugank Trivedi ', persentage: 'CAT  : 98.5 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/sourav.jpg', name: 'Sourav Naik', persentage: 'CAT : 98.3 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/shreya.jpg', name: 'Shreya Gupta', persentage: 'CAT : 98.11 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/dattatreya.jpg', name: 'Dattatreya Singh', persentage: 'CAT : 98.2 %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/priyesh.jpg', name: 'Priyesh Patel', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/nilesh.jpg', name: 'Nilesh Majumdar', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/mohitshah.png', name: 'Mohit Shah', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/sachin.jpg', name: 'Sachin Raj', persentage: 'CAT 98+ %Ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/akash.jpg', name: 'Akash Pandey', persentage: '99.76 in VARC' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Devendra Varma', persentage: '99.5 + in both LRDI & VARC' },
    { img: 'https://media.iquanta.in/ui_images/cat2019/anubhav.jpg', name: 'Anubhav Satapathy', persentage: 'from a mere 60%le to 96%le around' },
  ]
  rankers2017: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2017/shikhar.webp', name: 'Shikhar Sachdeva', persentage: 'CAT 99.98% ler ( QA 100% ler)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/gaurav.webp', name: 'Gaurav Saha ', persentage: 'CAT 99.90 %ler (CAT 99.92 %le in Quant)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/aabhas.webp', name: 'Aabhas Mathur', persentage: '99.85 %ler(CAT 99.96 in Quant)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/suhrit.jpg', name: 'Suhrit Sur ', persentage: 'CAT 99.85 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sameer.jpg', name: 'Sameer Sodani ', persentage: 'CAT 99.80 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/siddharth.jpg', name: 'Siddharth Sridhar', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sahil.jpg', name: 'Sahil Aggarwal ', persentage: 'CAT 99.77 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bharat.jpg', name: 'Bharat Santani ', persentage: 'CAT 99.67 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/siddhartha.jpg', name: 'Siddhartha Choudhury', persentage: 'CAT 99.63 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sourav.jpg', name: 'Sourav Bikash ', persentage: 'CAT 99.58 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/harshit.jpg', name: 'Harshit Sharma', persentage: 'CAT 99.54 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aditya Kumar Singh ', persentage: 'CAT 99.4 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bijay.jpg', name: 'Bijay Sharma', persentage: 'CAT 99.36 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/digvijay.jpg', name: 'Digvijay Sinha ', persentage: 'CAT 99.29 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/soham.jpg', name: 'Soham De', persentage: 'CAT 99.28 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/ben.jpg', name: 'Ben Harison ', persentage: 'CAT 99.25 (awesome raise from 90.25 last year)' },
    { img: 'https://media.iquanta.in/ui_images/ananta.webp', name: 'Ananta Chhajer ', persentage: 'CAT 99.21 (you deserve a 100 next year)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/bhavya.jpg', name: 'Bhavya Shah ', persentage: 'CAT 99.12 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/prateek.jpg', name: 'Prateek Gambhir ', persentage: 'CAT 99.10 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aman Jain ', persentage: 'CAT 99.07 (Sabse jada doubts puchne wala from course  :p )' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/himanshu.jpg', name: 'Himanshu Singla', persentage: 'CAT 99.06 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sounak.jpg', name: 'Sounak Kundu ', persentage: 'CAT 99.04 (you deserve more, youll get more)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/abhishek.jpg', name: 'Abhishek Paul  ', persentage: 'CAT 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/navneet.jpg', name: 'Navneet Gulati ', persentage: 'CAT 99.02 (very consistent boy wid prep)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/adarsh.jpg', name: 'Adarsh Srivastava ', persentage: 'CAT 99 (hardworking boy)' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/naman.jpg', name: 'Naman Chaudhary', persentage: 'CAT 82 to 98' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/aditya.jpg', name: 'Aditya Anand', persentage: 'CAT 93 to 98 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pranav Khera', persentage: 'CAT  87 to 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/upasana.jpg', name: 'Upasana Ghosh', persentage: 'CAT  60%le to 93' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Himanshu Sharma', persentage: 'CAT 72 to 97%le ' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/subhadev.jpg', name: 'Subhadev Pal ', persentage: 'CAT 98.6 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/sambhid.jpg', name: 'Sambhid Gourav  ', persentage: 'CAT 95 %le' },
    { img: 'https://media.iquanta.in/ui_images/cat2017/akash.jpg', name: 'Akash Bansal ', persentage: 'CAT 97.7 %le' }
  ]

  rankers2016: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2016/viraat.jpg', name: 'Viraat Gupta', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/dhruv.webp', name: 'Dhruv Gupta', persentage: 'CAT 99.98 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Debasmita Kumar', persentage: 'CAT 99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/aditya.jpg', name: 'Aditya Chandrayan', persentage: 'CAT 99.72 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/gaurav.jpg', name: 'Gaurav Gupta', persentage: 'CAT 99.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Anmol Narang', persentage: 'CAT 99.46  %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/prince.jpg', name: 'Prince Jain', persentage: 'CAT 99.48 %ler' },
    { img: 'https://media.iquanta.in/ui_images/pratik.webp', name: 'Pratik Sahoo ', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pawan Rathi', persentage: 'CAT 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aritra Chakrabarti ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Piyush Joshi ', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/anirban.jpg', name: 'Anirban Sinha', persentage: 'CAT 99.17 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/anubhav.jpg', name: 'Anubhav Sinha ', persentage: 'CAT 99.67 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/ankit.jpg', name: 'Ankit Kumar ', persentage: 'CAT  99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/akshat.jpg', name: 'Akshat Jain  ', persentage: 'CAT  99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/soumya.jpg', name: 'Soumya Ranjan Tripathy', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Akshat Gupta ', persentage: 'CAT 99.61 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jake Anderson', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/nayan.jpg', name: 'Nayan Chatterjee', persentage: 'CAT 99.84 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/sandeep.jpg', name: 'Sandeep Patra ', persentage: 'CAT 99.6 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/abhishek.jpg', name: 'Abhishek Maurya  ', persentage: 'CAT 99.39 %ler' }
  ]

  rankers2015: any[] = [
    // { img: 'https://media.iquanta.in/ui_images/cat2015/prateek.webp', name: 'Prateek Bajpai ', persentage: 'The CAT 100 %ler (250 marks) ' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/sabyasachi.webp', name: 'Sabyasachi Mishra', persentage: 'CAT 100 %ler' },
    { img: 'https://media.iquanta.in/ui_images/rahul.webp', name: 'Rahul Das', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Dhruv+Bindal.jpg', name: 'Dhruv Bindal', persentage: 'CAT 99.94 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Mohit+Jain.jpg', name: 'Mohit Jain', persentage: 'CAT 99.93 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/siddharth.jpg', name: 'Siddharth Sridhar', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Atul+Gandhi.jpg', name: 'Atul Gandhi', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sumit Ranjan', persentage: 'CAT  99.85 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/gursimran.jpg', name: 'Gursimran Ahuja', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Nishchay+Nath.jpg', name: 'Nishchay Nath', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Lakshay+Pandhi.jpg', name: 'Lakshay Pandhi', persentage: 'CAT 99.7 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Debarshee+Mitra.jpg', name: 'Debarshee Mitra', persentage: 'CAT 99.68 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rhitwiz Tripathi', persentage: 'CAT 99.68 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Rahul+Dubey.jpeg', name: 'Rahul Dubey', persentage: 'CAT 99.62 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/malay.jpg', name: 'Malay Krishna', persentage: 'CAT 99.62 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/Rajan+Pandey.jpeg', name: 'Rajan Pandey', persentage: 'CAT 99.92 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2015/akshat.jpg', name: 'Akshat Gupta', persentage: 'CAT 99.6 %ler' }
  ]


  rankers2021: any[] = [
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Gauravi+Kabadi.png', name: 'Gauravi Kabadi', persentage: 'CAT 99.95 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rishabh Bansal', persentage: 'CAT 99.95 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Uttkarsh Arora', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Atharva Kanitkar', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Biman+Barai.png', name: 'Biman Barai ', persentage: 'CAT 99.83 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Devansh+Tyagi.png', name: 'Devansh Tyagi ', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Sukhveen+Kaur.png', name: 'Sukhveen Kaur', persentage: 'CAT 99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Rajat+Tiwary.png', name: 'Rajat Tiwary', persentage: 'CAT  99.66 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pallavi M ', persentage: 'CAT 99.64 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Aditya+Tripathi.png', name: 'Aditya Tripathi', persentage: 'CAT 99.59 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Gautam+Rai.png', name: 'Gautam Rai ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Rounak+Das.png', name: 'Rounak Das ', persentage: 'CAT 99.56 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Siddhant+Bhagat.png', name: 'Siddhant Bhagat', persentage: 'CAT 99.53 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Satya Sripada', persentage: 'CAT 99.51 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Srinath Rao', persentage: 'CAT 99.46 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Shivam+Dubey.png', name: 'Shivam Dubey ', persentage: 'CAT 99.39 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Dhruv+Jhalani.png', name: 'Dhruv Jhalani', persentage: 'CAT 99.31 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Vidisha Chintalapudi', persentage: 'CAT 99.21 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Ravi+Ranjan.png', name: 'Ravi Ranjan', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Jaju', persentage: 'CAT 99.19 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Sudhanshu kumar ', persentage: 'CAT 99.18 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Naveen Krishna ', persentage: 'CAT 99.1 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tanush Meshram ', persentage: 'CAT 99.09 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Samarth+Vats.jpg', name: 'Samarth Vats ', persentage: 'CAT 99.03 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Pratyush Pratap Saikia ', persentage: 'CAT  99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Tushaar ERr ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Sehaj+Miglani.png', name: 'Sehaj Miglani ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rohith Siva Ganesh ', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jefrin Sabu', persentage: 'CAT 99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Akshay Bhargava', persentage: '98.45%le NMAT 251' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Asmeet Kaur', persentage: 'CAT 98+ %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shashwat', persentage: 'CAT 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Aayushi Dubey ', persentage: 'CAT 97 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Garima Bedi ', persentage: 'CAT 96.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2021+RESULT/Shantanu+Bhowmick.png', name: 'Shantanu Bhowmick ', persentage: 'CAT 95.5 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubhashish Gargari', persentage: 'Best 95 %ler' }

  ]

  rankers2022: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Mridul Agarwal', persentage: 'CAT 99.99 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Adarsh+Khandelwal.png', name: 'Adarsh Khandelwal ', persentage: 'CAT 99.93 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Geetsaisumant+Jupudi.jpeg', name: 'Geetsaisumant Jupudi ', persentage: 'CAT 99.9 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Pranav+Bahedia.jpg', name: 'Pranav Bahedia', persentage: 'CAT 99.82 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Atish+Naskar.jpeg', name: 'Atish Naskar', persentage: 'CAT 99.81 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Siddharth Pandey', persentage: 'CAT 99.78 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Jaju', persentage: 'CAT 99.74 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Pavan+Ch.jpg', name: 'Pavan Ch', persentage: 'CAT  99.73 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Gaurav+Harlalka.jpg', name: 'Gaurav Harlalka', persentage: 'CAT 99.70 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Rishab+Rahiman.jpg', name: 'Rishab Rahiman', persentage: 'CAT 99.63 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Kapil+Yadav.jpg', name: 'Kapil Yadav', persentage: 'CAT 99.59 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Govinda+Aditya.jpg', name: 'Govinda Aditya', persentage: 'CAT 99.53 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Manan ', persentage: 'CAT 99.50 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Kshitij+Singhal.jpg', name: 'Kshitij Singhall', persentage: 'CAT 99.44 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Harkiran+Chawla.png', name: 'Harkiran Chawla', persentage: 'CAT 99.41 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Chinmay+Paltewar.jpg', name: 'Chinmay Paltewar', persentage: 'CAT 99.35 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Sanjit+Sarkar.jpg', name: 'Sanjit Sarkar', persentage: 'CAT 99.28 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Vaibhav+Singh.png', name: 'Vaibhav Singh', persentage: 'CAT 99.25 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Arpit Gaur ', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Shubham Gupta ', persentage: 'CAT 99.2 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Samyak Jain ', persentage: 'CAT 99.19 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'aman sharma', persentage: 'CAT 99.13 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Nimish More ', persentage: 'CAT 99.12 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Sai+Santosh.jpg', name: 'Sai Santosh', persentage: 'CAT 99.08 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Tanya+Jain.png', name: 'Tanya Jain', persentage: 'CAT  99.05 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Jasmeet Kaur ', persentage: 'CAT 99.02 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Imran+Anas.jpg', name: 'Imran Anas', persentage: 'CAT 98.8 %ler' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Srajal Dwivedi', persentage: 'CAT 98.60 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Ayan+Ganguly.jpg', name: 'Ayan Ganguly ', persentage: 'CAT 98.52 %ler' },
    { img: 'https://media.iquanta.in/ui_images/CAT+2022+RESULT/Madhushree+Gupta.jpg', name: 'Madhushree Gupta', persentage: 'CAT 98.5 %ler' }
  ]

  rankerscuet2023: any[] = [
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/8.jpg', name: 'Mansi Gupta ', branch: 'Commerce', Marks: '791/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/1.jpg', name: 'Bharat Periwal', branch: 'Commerce', Marks: '761/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/17.jpg', name: 'Rishab ', branch: 'Commerce', Marks: '785/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/9.jpg', name: 'Akash Dwivedi ', branch: 'Humanities', Marks: '769/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/11.jpg', name: 'Yogita Sharma ', branch: 'Commerce', Marks: '780/800' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Gareema', branch: 'Commerce', Marks: '770/800' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Siddharth', branch: 'Commerce', Marks: '759/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/28.jpg', name: 'Ron Timung', branch: 'Commerce', Marks: '752/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/15.jpg', name: 'Naiyah', branch: 'Humanities', Marks: '775/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/16.jpg', name: 'Ishita', branch: '', Marks: '762/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/6.jpg', name: 'Siya Thakran', branch: 'Humanities', Marks: '706/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/5.jpg', name: 'Surmeet Kaur', branch: 'Commerce', Marks: '728/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/2.jpg', name: 'Midhun Raj', branch: 'Commerce', Marks: '738/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/4.jpg', name: 'Arushi Pal', branch: 'Humanities', Marks: '744/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/3.jpg', name: 'Choutisha Tamuli', branch: 'Humanities', Marks: '736/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/36.jpeg', name: 'Jiteesha', branch: 'Humanities', Marks: '781/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/10.jpg', name: 'G Rajalakshmi', branch: 'Commerce', Marks: '721/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/34.jpg', name: 'Chirag Aggrawal', branch: 'Commerce', Marks: '740/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/37.jpeg', name: 'Gurpreet', branch: 'Commerce', Marks: '721/800' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Rimi Saloi', branch: 'Humanities', Marks: '708/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/27.jpg', name: 'Ishan', branch: 'Commerce', Marks: '700/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/22.jpg', name: 'Tannishtha', branch: 'Commerce', Marks: '713/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/38.jpeg', name: 'Angela', branch: 'Commerce', Marks: '718/800' },
    { img: 'https://media.iquanta.in/ui_images/cuet/toppers/26.jpg', name: 'Anchal', branch: 'Commerce', Marks: '716/800' },
    { img: 'https://media.iquanta.in/ui_images/cat2016/jake-small.jpg', name: 'Prakhar ', branch: 'Commerce', Marks: '759/800' },
  ]

  rankerscuet2022: any[] = []

  main_team_list: any[] = [
    {
      "language": "en",
      "team": "Marketing & Growth",
      "name": "Sumedha",
      "designation": "Co-Founder & CEO",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/sumedha_web.png"
    },
    {
      "language": "en",
      "team": "Marketing & Growth",
      "name": "Shireen",
      "designation": "Co-Founder & COO",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/shireen_web.png"
    },
    {
      "language": "en",
      "team": "Content Team",
      "name": "Divya Raman",
      "designation": "Head - Content",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/divya_web_2.png"
    },
    {
      "language": "en",
      "team": "Marketing & Growth",
      "name": "Kartik B",
      "designation": "Growth Marketing Manager",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/karthik_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Priyasha Sen",
      "designation": "Customer Success Manager",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/priyasha_web.png"
    },
    {
      "language": "en",
      "team": "Engineering & Product",
      "name": "Mrinmay Date",
      "designation": "Product Manager",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/mrinmay_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Tushar Ghosh",
      "designation": "Sales Team Lead",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/tushar_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Aruja Sharma",
      "designation": "Sales Team Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/aruja_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Biprojit Chakraborty",
      "designation": "Sales Team Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/biprojit_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Iqra Fathima",
      "designation": "Sales Team Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/iqra_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Manisha Agarwal",
      "designation": "Customer Success Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/manisha_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Maya P.G",
      "designation": "Sales Team Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/maya_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Prabina Begam",
      "designation": "Customer Success Executive",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/prabina_web.png"
    },
    {
      "language": "en",
      "team": "Sales & Support",
      "name": "Twinkle Chawla",
      "designation": "Executive - Programs",
      "web_image_url": "https://soicalprod.s3.ap-southeast-1.amazonaws.com/home_page/twinkle_web.png"
    }
  ]

  ipmattoppers: any[] = [
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-1.jpeg', name: 'Tanmay Pruthi ', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-2.jpeg', name: 'Aditya pandey ', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-3.jpeg', name: 'Sandeep ', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-4.jpeg', name: 'sumita pradhan ', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-5.jpeg', name: 'G Rajlakshmi', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-6.jpeg', name: 'Yash Salviya', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-7.jpeg', name: 'Riya arora', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-8.jpeg', name: 'Subin', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-9.jpeg', name: 'Mansavi Garg', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-10.jpeg', name: 'Vedant', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-11.jpeg', name: 'Parth mehrotra', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-12.jpeg', name: 'Sameekhsa', Marks: 'St. Xaviers Mumbai(BMS)' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-13.jpeg', name: 'Navya', Marks: 'SCMS Pune' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-14.jpeg', name: 'Mehak', Marks: 'SCMS Pune' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-15.jpeg', name: 'Aryan Raj', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-16.jpg', name: 'Yash', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-17.jpg', name: 'Akshat jain', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-18.jpg', name: 'Daksh modi', Marks: 'Cracked IPMAT IIM Indore' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-19.jpeg', name: 'Aaryan Gupta ', Marks: 'NIRMA' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-20.jpeg', name: 'Tanmay gupta', Marks: 'SYMBIOSIS' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-22.jpeg', name: 'Rishabh kedia', Marks: 'NMIMS Mumbai BBA' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-23.jpeg', name: 'Sujal', Marks: 'NIRMA' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-24.jpeg', name: 'Ananya', Marks: 'Christ BBA , NMIMS' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-25.jpeg', name: 'Rachit Bajaj', Marks: 'St Xaviers Kolkata' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-26.jpeg', name: 'Tanmay gupta', Marks: 'SCMS Pune' },
    { img: 'https://media.iquanta.in/ui_images/ipmat-result-27.jpeg', name: 'Disha', Marks: 'Nmims Mumbai' },



  ]

  courseComparison: any[] = [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Assignments', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Quants Videos', colorText: "Non-Engineer's ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'VARC Videos', colorText: "Engineer's ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'LRDI Inception', colorText: "CAT ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'AI Mock Analysis', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '', colorText: 'Special initiatives (QA250,LRDI70)', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Peer to Peer Learing', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '2 Month Crash Course', colorText: 'Free ', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '7500 CAT Qs IIM ABC Course', colorText: '', subText: '', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'IIM ABC Practice Sessions', colorText: '', subText: '(Daily 12 QA, 3 RCs & 3 LRDI Sets)', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "12 Sets: CAT'23 level Books", colorText: '', subText: '', img1: '',
      img2: '', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
  ]

  courseComparison1: any[] = [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Assignments', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp'
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Non-Engineer's Quants Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "Engineer's VARC Videos", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'CAT LRDI Inception', colorText: " ", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'AI Mock Analysis', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Special initiatives (QA250,LRDI70)', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Peer to Peer Learing', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'Free 2 Month Crash Course', colorText: ' ', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: '7500 CAT Qs IIM ABC Course', colorText: '', subText: '', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: 'IIM ABC Practice Sessions', colorText: '', subText: '(Daily 12 QA, 3 RCs & 3 LRDI Sets)', img1: '',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
    {
      text: "12 Sets: CAT'24 level Books", colorText: '', subText: '', img1: '',
      img2: '', img3: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img4: ''
    },
  ]

  pastPapersContent: any[] = [
    {
      cat: `<h2 class="mt-md-4 text-center">CAT Question Paper with Detailed Solution</h2>
                <p class="text-center">Solving CAT Previous Year Papers along with iQuanta CAT Classes can make an aspirant geared up to at least 95% of his preparation. Check out the CAT Question Paper with Detailed Solutions.                </p>
                <h3 style="font-size: 21px;
                font-weight: 600;
                margin-bottom: 13px;">The pattern of the CAT exam:</h3>
                <p>The CAT paper has three sections, the first section is the VARC Section (Verbal Ability and Reading
                    Comprehension), the second section is the LRDI Section (Logical Reasoning and Data Interpretation),
                    and the third and last Section in the CAT exam is Quantitative Aptitude section.</p>
                <p>We have provided PYQ for the past 24 years and also there are several test modules of PYQ available
                    on our iQuanta website.</p>
                <p>The Previous year paper of CAT acts as a see-through to the exam's pattern, it gives clarity, types,
                    format and structure of questions. Thorough comprehension of the exam pattern helps in getting the
                    exact idea of what paper consists of acts as a transparent mirror, and visualises the structure of
                    questions. Students can make their strategy accordingly. PYQs are a trustworthy source to rely on
                    for your CAT Exam preparation. </p>
                <p>CAT previous year papers comprise three sections: Verbal Ability and Reading Comprehension, Logical
                    Reasoning and Data Interpretation, And Quantitative Aptitude. By preparing through previous years
                    questions students can master their strategy in the above five sections.</p>
                <h3 style="font-size: 21px;
                font-weight: 600;
                margin-bottom: 13px;">Why Solve CAT Previous Year Papers?</h3>
                <p>CAT Previous year papers evaluate the degree of complexity, by analyzing PYQ candidates can measure
                    the difficulty of the CAT exam. It helps in time management. You will be able to figure out the
                    exact time needed for each question and will be familiarised with the level of questions asked every
                    year, in this way, students get an idea of how they should allocate the time required in different
                    sections.</p>
                <p>Although the CAT syllabus gives a broad image of all the topics, the CAT previous year questions
                    picture the exact pattern and format of repeating or common questions every year. This familiarity
                    with paper helps students target the actual topics rather than going for the whole bucket of topics
                    and avoiding unnecessary elements from your strategy. This will help you deal with your anxiety and
                    help you in preparing a relevant strategy. </p>
                <p>CAT previous year papers are the best trustable source to calculate the areas where you lack and
                    where you are proficient, this will help you in putting the exact time needed for your weak points
                    and reinforcing their strong points. PYQ is the biggest asset for aspirants in any competitive exam.
                </p>
                <p>Increasing pace and accuracy is essential for scoring good grades in CAT. Practising through CAT
                    previous year question papers can help candidates in increasing time and speed per question and this
                    way they can attempt a maximum number of questions in a given time and make good grades in CAT.</p>
                <p>Confidence in CAT exams can help you in clearing your exams and students can gain confidence by
                    solving PYQ again and again, this will make them familiar with the pattern of questions asked and
                    can significantly boost the confidence of students.</p>
                <p>The LRDI section is one of the trickiest sections and if candidates are not aware of the pattern,
                    then it will bring difficulty as this is not some subject that has a fixed syllabus. Hence, solving
                    CAT Previous Year Papers will help you in analysing exactly what types of questions are asked in the
                    exam.</p>`,
      iift: ` <h2 class="mt-md-4 text-center">IIFT previous year papers </h2>
                <p class="text-center">This page has Past year papers of IIFT exam. Each year paper has been divided
                    into sectional exam that has been asked in IIFT exam.IIFT
                    exam is an entrance test for IIFT delhi, IIFT kolkata and IIFT kakinada Campus. IIFT exam has 4
                    sections which are </p>

                <div class="mx-auto" style="width: max-content;">
                    <p>1)Quantitative Aptitude,</p>
                    <p>2)Verbal ability and Reading comprehension</p>
                    <p>3)Logical reasoning and Data interpretation</p>
                    <p> 4)General knowledge.</p>
                </div>`,
      cmat: `  <h2 class="mt-md-4 text-center">CMAT previous year papers </h2>
                <p class="text-center">This page has Past year papers of CMAT exam. CMAT exam has 3 sections which are
                </p>

                <div class="mx-auto" style="width: max-content;">
                    <p>1)Quantitative Aptitude and LRDI</p>
                    <p>2)Verbal ability and Reading comprehension,</p>
                    <p> 3)General knowledge.</p>
                </div>`,
      xat: `    <p>Learn online XAT Previous Year Papers 2016 to 2024 from iQuanta. XAT Mock tests and exclusive
                    decision-making sessions for XAT exam to the aspirants.</p>
                <h2 class="mt-md-4  text-center">The pattern of XAT exam </h2>
                <p>The paper follows two sections, the first section consists of verbal and logical ability,
                    decision-making, and quantitative ability & data interpretation, and the other section talks about
                    general knowledge and essay writing.
                    We have provided PYQ for 8 years and also there are several test modules of PYQ available on our
                    website. </p>
                <p>Previous year papers of XAT are a see-through to the exam's pattern, it gives clarity, types, format
                    and structure of questions. Thorough comprehension of the exam pattern helps in getting the exact
                    idea of what paper consists of acts as a transparent mirror, and visualizes the structure of
                    questions. Students can make their strategy accordingly. PYQs are a trustworthy source to rely on
                    for your XAT preparation.</p>
                <p>XAT paper comprises five sections: Verbal and logical Ability, Quantitative Ability and Data
                    Interpretation, Decision Making, General Knowledge and Essay Writing. By preparing through previous
                    year's questions students can master their strategy in the above five sections.</p>`,

                    snap: ` <h2 class="mt-md-4 text-center">SNAP previous year papers </h2>
                    <p class="text-center">Enhance your SNAP preparation with our collection of SNAP Previous Year Papers. Familiarize yourself with the exam pattern, question types, and time management. </p>
                    <p>iQuanta also provides specific course for SNAP Test which includes videos for SNAP exam, Practice
                        sessions, Mocks and personal mentorship.</p>
                    <p> SNAP exam has 4 sections which are </p>
    
                    <div class="mx-auto" style="width: max-content;">
                        <p>1)Quantitative Aptitude, </p>
                        <p>2)VARC </p>
                        <p> 3)General knowledge
                        </p>
                        <p>4)LRDI.</p>
                    </div>`,

      tiss: ` <h2 class="mt-md-4 text-center">TISS previous year papers </h2>
                <p class="text-center">This page has Past year papers of TISS exam.Tiss exam is an entrance exam for
                    TISS college.Tiss exam has 4 sections which are</p>

                <div class="mx-auto" style="width: max-content;">
                    <p>1)Quantitative Aptitude,</p>
                    <p>2)Verbal ability and Reading comprehension, </p>
                    <p>3)LRDI.</p>
                    <p> 4)GK. 40% of this exam consist of GK portion </p>
                </div>
                <p class="text-center">If you want to prepare for this exam and specifically for its GK, You can enrol
                    for iQuanta GK course.
                </p>`,

                nmat: ` <h2 class="mt-md-4 text-center">NMAT previous year papers </h2>
                <p class="text-center">Enhance your NMAT exam readiness with NMAT Previous Year Papers. Gain valuable insights and practice for success. Access the key to acing the NMAT exam.</p>
                <p class="text-center">iQuanta also provides specific test series for NMAT exam and also NMAT exam
                    specific course which includes Videos, Mocks and personal mentorship.</p>
                <p class="text-center">NMAT exam has 3 sections which are</p>


                <div class="mx-auto" style="width: max-content;">
                    <p>1)Quantitative Skill,</p>
                    <p>2)Logical Reasoning, </p>
                    <p>3)Language Skills.</p>
                </div>`,

      clat: ` <h2 class="mt-md-4 text-center">CLAT UG Past Year Papers</h2>
                <p class="text-center">This page has CLAT UG & AILET Past Papers, with detailed solutions.</p>
                <div class="mx-auto" style="width: max-content;">
                    <p>1)Topic-wise Past CLAT Questions</p>
                    <p>2)Year-wise Past CLAT Questions </p>
                    <p>3)Take Past CLAT Papers as mock</p>
                </div>
                <p class="text-center">Solving these along with iQuanta CLAT UG Classes & practice assignments can get
                    you fully prepared to crack CLAT & AILET exams as well as other Law exams like SLAT, LSAT etc</p>`,

      cuet: `<h2 class="mt-md-4 text-center">CUET UG Past Year Papers </h2>
                <p class="text-center">This page has Past year papers of CUET UG with detailed solutions.</p>
                <div class="mx-auto" style="width: max-content;">
                    <p>1)Topic-wise Past CUET UG Questions</p>
                    <p>2)Year-wise Past CUET UG Questions </p>
                    <p>3)Take Past CUET UG Papers as mock</p>
                </div>
                <p class="text-center">Solving these along with iQuanta CUET UG Classes & practice assignments can get
                    you fully prepared to crack CUET UG with a great score to get into top universities in India.</p>
`
    }
  ]

  courseComparisonneet: any[] = [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', 
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'Best KOTA Study Material	', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', 
    },
   
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "AI Mock Analysis", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },

    {
      text: "Peer to Peer Learning", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "NEET LEVEL BOOKS", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
    },

    {
      text: "Free NEET Crash Course", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "FreeWB NEET CRASH COURSE", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "LIVE MENTORSHIP", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
  ]

   iimCallsContent:any [] = [
    {college: 'IIM Bangalore', link: 'https://hrm.iimb.ernet.in/iimb/2024-26_pgp/offer_wait_24.htm', image:'https://media.iquanta.in/ui_images/IIM+B.webp', icon:'https://media.iquanta.in/ui_images/IIMB.webp', collegeCode: 'IIMB', whatsappLink:'https://li.iquanta.in/nJ3mz'},
    {college: 'IIM Lucknow', link: 'https://www.iiml.ac.in/admission/student_dashboard', image:'https://media.iquanta.in/ui_images/IIM+L.webp', icon:'https://media.iquanta.in/ui_images/IIML.webp', collegeCode: 'IIML', whatsappLink:'https://li.iquanta.in/hSR1B'},
    {college: 'IIM Ahmedabad', link: 'https://pgpadm.iima.ac.in/2024/result/', image:'https://media.iquanta.in/ui_images/imma-banner-img.webp', icon:'https://media.iquanta.in/ui_images/IIMA.webp', collegeCode: 'IIMA', whatsappLink:'https://li.iquanta.in/TFivk'},
    {college: 'IIM Calcutta', link: 'https://application.iimcal.ac.in/', image:'https://media.iquanta.in/ui_images/IIM+C.webp', icon:'https://media.iquanta.in/ui_images/IIMC.webp', collegeCode: 'IIMC', whatsappLink:'https://li.iquanta.in/LcYw9'},
    {college: 'IIM Kozhikode', link: 'https://www.iimk.ac.in/admission_announcements', image:'https://media.iquanta.in/ui_images/IIM+K.webp', icon:'https://media.iquanta.in/ui_images/IIMK.webp', collegeCode: 'IIMK', whatsappLink:'https://li.iquanta.in/57bg1'},
    {college: 'IIM Indore', link: 'https://iimidr.ac.in/programmes/academic-programmes/', image:'https://media.iquanta.in/ui_images/IIM+I.webp', icon:'https://media.iquanta.in/ui_images/IIMI.webp', collegeCode: 'IIMI', whatsappLink:'https://li.iquanta.in/LGOtm' },
    {college: 'SP Jain', link: 'https://pgdmadmissions.spjimr.org/', image:'https://media.iquanta.in/ui_images/spjain-college.avif', icon:'https://media.iquanta.in/ui_images/spjain.png', collegeCode: 'SP Jain', whatsappLink:'https://li.iquanta.in/30NU0' },
    {college: 'IIM CAP', link: 'https://cap2025.iimbg.ac.in/login', image:'https://media.iquanta.in/ui_images/iim-cap.jpg', icon:'https://media.iquanta.in/ui_images/iim-cap-logo.png', collegeCode: 'IIM CAP', whatsappLink:'https://chat.whatsapp.com/HylSinfKlfo6qNVlTALhBV' },
    {college: 'IIM Shillong', link: 'https://apply.iimshillong.ac.in/admissions-iimshl-2025/login', image:'https://media.iquanta.in/ui_images/iim-shillong.jpg', icon:'https://media.iquanta.in/ui_images/iim-shillong.png', collegeCode: 'IIM Shillong', whatsappLink:'https://chat.whatsapp.com/Bzh9Hwz05Vr5YDWWqt5ADO' },
    {college: 'IIM Rohtak', link: 'https://admission.iimrohtak.ac.in/SignIn/pgp-2025-27', image:'https://media.iquanta.in/ui_images/iim-rohtak-college.jpeg', icon:'https://media.iquanta.in/ui_images/iim-rhtak.png', collegeCode: 'IIM Rohtak', whatsappLink:'https://chat.whatsapp.com/BpT38vtYLZjC6sliCdj300' },
    {college: 'SIBM Pune', link: 'https://snap2024.ishinfosys.com/SNAPGEPISlotbookingY25/', image:'https://media.iquanta.in/ui_images/sibm-pune-college.jpg', icon:'https://sibm.edu/assets/images/fevi.png', collegeCode: 'SIBM Pune', whatsappLink:'https://chat.whatsapp.com/EMGg6urb7EEG2xCS6fu4QC' },
    {college: 'XLRI', link: '', image:'https://media.iquanta.in/ui_images/xlri.png', icon:'https://www.xlri.ac.in/favicon.ico', collegeCode: 'XLRI', whatsappLink:'https://chat.whatsapp.com/LkZFSPvDH9JGROKXQ3fqSG' },
    {college: 'NMIMS', link: ' https://apply.nmims.edu/', image:'https://media.iquanta.in/ui_images/nmims.jpg', icon:'https://www.nmims.edu/images/favicon.ico', collegeCode: 'NMIMS', whatsappLink:'https://chat.whatsapp.com/EAW8MPQfwi46yEvrJLVfCl' },
    {college: 'FMS', link: '', image:'https://media.iquanta.in/ui_images/fms-college.jpeg', icon:'https://fms-static.b-cdn.net/common/fmsLogo.svg', collegeCode: 'FMS', whatsappLink:'https://chat.whatsapp.com/C9wC8rMuLezK2iReGaLG63' },
    {college: 'GLIM', link: '', image:'https://media.iquanta.in/ui_images/glim.jpg', icon:'https://www.greatlakes.edu.in/chennai/assets/greatlakes/icons/favicon-3.ico', collegeCode: 'GLIM', whatsappLink:'https://chat.whatsapp.com/F0DDQKf7C1RGSKPDnCzE7F' },
    {college: 'MDI Gurgaon', link: '', image:'https://media.iquanta.in/ui_images/mdig-college.jpeg', icon:'https://www.mdi.ac.in/resources/assets/images/mdi-favicon.png', collegeCode: 'MDIG', whatsappLink:'https://chat.whatsapp.com/HJN5swzy9Hc67N2dJBKh7F' },
 
  ]

  courseComparisoniit: any[] = [
    {
      text: 'Live Conceptual Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', 
    },
    {
      text: 'Application Classes', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'All Year Practice Sessions', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'Best KOTA Study Material	', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp', 
    },
   
    {
      text: '24*7 Doubt Solving', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '', 
    },
    {
      text: 'Full Mocks with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
    },
    {
      text: 'Sectionals with Video Solution', colorText: '', subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "AI Mock Analysis", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },

    {
      text: "Peer to Peer Learning", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "JEE LEVEL BOOKS", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
    },

    {
      text: "Free JEE Main Crash Course", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "Free BITSAT CRASH COURSE", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "Free JEE ADVANCED CRASH COURSE", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "FreeWB JEE CRASH COURSE", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
    {
      text: "LIVE MENTORSHIP", colorText: "", subText: '', img1: 'https://www.iquanta.in/blog/wp-content/uploads/2024/09/check-price-66e2c503c5690.webp',
      img2: '',
    },
  ]

  cmatBschoolList: any [] = [
    {
        "College_Name": "JBIMS, Mumbai",
        "Courses_Offered": "MMS",
        "Fees": "6-7 Lakhs",
        "Average_Package": "26.1 LPA",
        "percentile": "99.98"
    },
    {
        "College_Name": "SIMSREE, Mumbai",
        "Courses_Offered": "MMS",
        "Fees": "4.5 Lakhs",
        "Average_Package": "15.59 LPA",
        "percentile": "99.94"
    },
    {
        "College_Name": "KJ Somaiya Institute of Management, Mumbai",
        "Courses_Offered": "MBA, PGDM",
        "Fees": "17.3 Lakhs",
        "Average_Package": "11 LPA",
        "percentile": "99.2"
    },
    {
        "College_Name": "Great Lakes Institute of Management, Chennai",
        "Courses_Offered": "PGDM",
        "Fees": "22 Lakhs",
        "Average_Package": "13.1 LPA",
        "percentile": "99.06"
    },
    {
        "College_Name": "GIM, Goa",
        "Courses_Offered": "PGDM",
        "Fees": "21 Lakhs",
        "Average_Package": "11.22 LPA",
        "percentile": "99.85"
    },
    {
        "College_Name": "WeSchool, Mumbai",
        "Courses_Offered": "PGDM",
        "Fees": "17 Lakhs",
        "Average_Package": "12 LPA",
        "percentile": "70"
    },
    {
        "College_Name": "NIBM, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "16 Lakhs",
        "Average_Package": "14.16 LPA",
        "percentile": "98.5"
    },
    {
        "College_Name": "PUMBA, Pune",
        "Courses_Offered": "MBA",
        "Fees": "4.4 Lakhs",
        "Average_Package": "8.85 LPA",
        "percentile": "99.95"
    },
    {
        "College_Name": "XISS, Ranchi - BM",
        "Courses_Offered": "PGDM",
        "Fees": "8.9 Lakhs",
        "Average_Package": "11 LPA",
        "percentile": "95"
    },
    {
        "College_Name": "XISS, Ranchi - HRM",
        "Courses_Offered": "PGDM",
        "Fees": "8.9 Lakhs",
        "Average_Package": "7.4 LPA",
        "percentile": "95"
    },
    {
        "College_Name": "BIMTECH, Greater Noida",
        "Courses_Offered": "PGDM",
        "Fees": "14 Lakhs",
        "Average_Package": "11 LPA",
        "percentile": "75"
    },
    {
        "College_Name": "IFMR Graduate School of Business at KREA University, Sri City",
        "Courses_Offered": "MBA",
        "Fees": "14.56 Lakhs",
        "Average_Package": "13.5 LPA",
        "percentile": "85"
    },
    {
        "College_Name": "IMT, Nagpur",
        "Courses_Offered": "PGDM",
        "Fees": "15.12 Lakhs",
        "Average_Package": "10.81 LPA",
        "percentile": "90"
    },
    {
        "College_Name": "SIESCOMS, Navi Mumbai",
        "Courses_Offered": "PGDM",
        "Fees": "6.3 Lakhs",
        "Average_Package": "8.11 LPA",
        "percentile": "84"
    },
    {
        "College_Name": "XIME, Bengaluru",
        "Courses_Offered": "PGDM",
        "Fees": "11 Lakhs",
        "Average_Package": "14.3 LPA",
        "percentile": "75"
    },
    {
        "College_Name": "IPE, Hyderabad",
        "Courses_Offered": "PGDM",
        "Fees": "11.15 Lakhs",
        "Average_Package": "7.1 LPA",
        "percentile": "82"
    },
    {
        "College_Name": "KSOM, Bhubaneswar",
        "Courses_Offered": "MBA",
        "Fees": "13.6 Lakhs",
        "Average_Package": "6.5 LPA",
        "percentile": "80"
    },
    {
        "College_Name": "AIMS, Bangalore",
        "Courses_Offered": "MBA",
        "Fees": "9 Lakhs",
        "Average_Package": "7.5 LPA",
        "percentile": "80"
    },
    {
        "College_Name": "Birla Institute of Technology (BIT), Mesra",
        "Courses_Offered": "MBA",
        "Fees": "5.5 Lakhs",
        "Average_Package": "6 LPA",
        "percentile": "75"
    },
    {
        "College_Name": "SCMS Cochin School of Business, Cochin",
        "Courses_Offered": "PGDM",
        "Fees": "8.25 Lakhs",
        "Average_Package": "6.5 LPA",
        "percentile": "70"
    },
    {
        "College_Name": "GIBS, Bangalore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 9.50 Lakhs",
        "Average_Package": "INR 7.40 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ISBR, Bangalore",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA - 10.00 Lakhs PGDM - 11.00 Lakhs \n Global PGDM - 13 Lakh /- (Three Country Program",
        "Average_Package": "INR 8.0 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IIBS, Bangalore",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA / PGDM - INR 9.45 Lakhs",
        "Average_Package": "INR 8.0 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Alliance University, Bangalore",
        "Courses_Offered": "MBA",
        "Fees": "INR 15.00 Lakh (Main Campus)\n INR 10.00 Lakh (City Campus)",
        "Average_Package": "INR 8.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ISB&M, Kolkata",
        "Courses_Offered": "PGDM",
        "Fees": "10.98 Lakh",
        "Average_Package": "10.8 Lkah",
        "percentile": "40"
    },
    {
        "College_Name": "BITM, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "2.56 L",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "Atlas Skilltech University, Mumbai",
        "Courses_Offered": "MBA",
        "Fees": "INR 11.45 Lakhs",
        "Average_Package": "INR 9 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IIEBM, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "INR 9.05 Lakh",
        "Average_Package": "INR 7.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ISMS, Pune",
        "Courses_Offered": "PGDM / MBA",
        "Fees": "PGDM - 7.50 Lakh\n MBA - 6.90 Lakh",
        "Average_Package": "INR 6 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "GNIOT, Greater Noida",
        "Courses_Offered": "MBA / PGDM",
        "Fees": "MBA-INR .... Lakhs PGDM-INR 8.37 Lakhs",
        "Average_Package": "INR 6.46 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Fostiima Business School, New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10.95 Lakh",
        "Average_Package": "INR 10.76 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "SBS, Amhedabad",
        "Courses_Offered": "PGDM",
        "Fees": "INR 7.45 Lakhs",
        "Average_Package": "INR 8.65 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ISME, Bangalore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10.45 Lakh",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IBA, Bangalore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10.32 Lakh",
        "Average_Package": "INR 7.80 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "RCM, Bangalore",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA / PGDM - INR 8.60 Lakh",
        "Average_Package": "INR 8.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ABBS, Bangalore",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA/PGDM-INR 8.90 Lakhs",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "GLBIMR, Greater Noida",
        "Courses_Offered": "PGDM",
        "Fees": "INR 7.85 Lakh",
        "Average_Package": "INR.8.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "BML Munjal university, Gurgaon",
        "Courses_Offered": "MBA",
        "Fees": "INR 14.60 Lakh",
        "Average_Package": "INR 8.0 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "FIIB, New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 11.55 Lakh",
        "Average_Package": "INR 8.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "EMPI, New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 8.30 Lakhs",
        "Average_Package": "INR 8.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Brainware University, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "4.54 L",
        "Average_Package": "3.5 L +",
        "percentile": "40"
    },
    {
        "College_Name": "CIEM, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "4.75 L",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "MDIM, Murshidabad",
        "Courses_Offered": "PGDM",
        "Fees": "INR 15.51 Lakh (including Fooding & Living)",
        "Average_Package": "11.76 L",
        "percentile": "40"
    },
    {
        "College_Name": "Universal Ai University (UBS), Mumbai",
        "Courses_Offered": "MBA",
        "Fees": "MBA in Single Spec. - 9.98\n MBA in Dual Spec. - 11.98",
        "Average_Package": "INR 15.32 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "MYRA, Mysore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10 Lakhs",
        "Average_Package": "INR 8.46 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IBMR, Pune",
        "Courses_Offered": "PGDM / MBA",
        "Fees": "PGDM - 7.50 Lakh\n MBA - 4.80 Lakh\n PGDM (Agri.) - 6 Lakh",
        "Average_Package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "DPU, Tathawade Pune",
        "Courses_Offered": "PGDM",
        "Fees": "PGDM 8.46 Lakh\n PGDM Global - 12.50 Lakh",
        "Average_Package": "INR 8.01 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "RIIM, Pune",
        "Courses_Offered": "PGDM / MBA",
        "Fees": "MBA + EMP : 5.90 Lakh\n MBA + MDP : 6.90 Lakh\n PGDM + IBEP - DUBAI : 8.10 Lakh\n PGDM + IBEP - DUBAI (Agri. & Pharma) : 8.10 Lakh\n PGDM + IBEP - UK/France : 10.00 Lakh",
        "Average_Package": "INR 5.95 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "NSHM Knowledge Campus, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "6.2 L",
        "Average_Package": "5.6 L",
        "percentile": "40"
    },
    {
        "College_Name": "UPES, Dehradun",
        "Courses_Offered": "MBA",
        "Fees": "INR 16.50 Lakhs",
        "Average_Package": "INR 7.02 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "",
        "Courses_Offered": "MBA",
        "Fees": "6.45 L (PGDM), 10.10 L (PGDM-BA)",
        "Average_Package": "5.5 L",
        "percentile": "40"
    },
    {
        "College_Name": "IBMR, Gurgaon",
        "Courses_Offered": "MBA / PGDM",
        "Fees": "MBA+PGPM - INR 5.34 Lakh PGDM+PGPM - INR 6.75 Lakh",
        "Average_Package": "INR 9.4 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IILM,Greater Noida",
        "Courses_Offered": "MBA",
        "Fees": "INR 11.7 Lakhs",
        "Average_Package": "INR 8 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IILM, Gurgaon",
        "Courses_Offered": "MBA",
        "Fees": "INR 12.30 Lakhs",
        "Average_Package": "INR 8.6 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "JIM, Noida",
        "Courses_Offered": "PGDM",
        "Fees": "INR 15.75 Lakhs",
        "Average_Package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "JIM, Lucknow",
        "Courses_Offered": "PGDM",
        "Fees": "INR 14.75 Lakh",
        "Average_Package": "9.05 L",
        "percentile": "40"
    },
    {
        "College_Name": "JIM, Indore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 12.75 Lakh",
        "Average_Package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "JIM, Jaipur",
        "Courses_Offered": "PGDM",
        "Fees": "INR 13.75 Lakh",
        "Average_Package": "INR 11.08 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ASM, Dwarka",
        "Courses_Offered": "PGDM",
        "Fees": "INR 9.7 Lakh",
        "Average_Package": "INR 8.47 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "SSIM, Hyderabad",
        "Courses_Offered": "PGDM",
        "Fees": "INR 6.9 Lakhs",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Woxsen University, Hyderabad",
        "Courses_Offered": "MBA",
        "Fees": "INR 14.4 Lakhs",
        "Average_Package": "INR 9.04 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Taxila Business School, JAIPUR",
        "Courses_Offered": "PGDM",
        "Fees": "Plan A - 9.50 Lakhs\n Plan B - 10.20 Lakh",
        "Average_Package": "INR 11.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "CBS, Kolkata",
        "Courses_Offered": "PGDM",
        "Fees": "7.45 L",
        "Average_Package": "7.45 L - 7.96 L",
        "percentile": "40"
    },
    {
        "College_Name": "PIBM, Pune",
        "Courses_Offered": "PGDM / MBA",
        "Fees": "INR 9.25 Lakhs",
        "Average_Package": "INR 9.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Akemi Business School, Pune",
        "Courses_Offered": "MBA",
        "Fees": "MBA+MDP- INR 5.90 Lakhs",
        "Average_Package": "INR 6.87 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "KCM, Bangalore",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA-INR 5.65 Lakhs PGDM-INR 7.50 Lakhs",
        "Average_Package": "INR 8.67 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IFIM, Bangalore",
        "Courses_Offered": "MBA",
        "Fees": "INR 10.00 Lakhs",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "KIAMS, Harihar Bangalore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10.85 Lakhs",
        "Average_Package": "INR 8.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "SIMS, Bangalore",
        "Courses_Offered": "MBA",
        "Fees": "INR 5.50 Lakhs",
        "Average_Package": "INR 2.64 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "RIMS, Bangalore",
        "Courses_Offered": "PGDM",
        "Fees": "INR 8.41 Lakhs",
        "Average_Package": "INR 6.48 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Sandip University, Sijoul Bihar",
        "Courses_Offered": "MBA",
        "Fees": "2.20 LAKHS",
        "Average_Package": "INR 2 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "FIRM, Coimbatore, Chennai",
        "Courses_Offered": "PGDM",
        "Fees": "INR 9.90 Lakh",
        "Average_Package": "INR 6.0 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Doon Business School, Dehrahun",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA-INR 6.50 Lakhs PGDM-INR 6.74 Lakhs",
        "Average_Package": "INR 8.75 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "LLOYD Business School, Greater Noida",
        "Courses_Offered": "MBA / PGDM",
        "Fees": "Dual Specialization (Without Analytics) - 8 Lakh\n Dual Specialization (With Analytics) - 8.50 Lakh",
        "Average_Package": "INR 6.58 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Asian Business School, Noida",
        "Courses_Offered": "PGDM",
        "Fees": "INR 9.00 Lakhs",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "JKBS, Gurugram New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 7.99 Lakhs",
        "Average_Package": "INR 7.0 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ITS, Gaziabaad",
        "Courses_Offered": "MBA/PGDM",
        "Fees": "MBA- INR 3.44 Lakhs PGDM-INR 6.40 Lakh",
        "Average_Package": "INR 5.65 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "JIM, Ghaziabad",
        "Courses_Offered": "MBA / PGDM",
        "Fees": "INR MBA-4.50 lakhs,INR PGDM-8.20 Lakhs",
        "Average_Package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "IILM, Lodhi Road New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 12.30 Lakhs",
        "Average_Package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "NDIM, New Delhi",
        "Courses_Offered": "PGDM",
        "Fees": "INR 12.75 Lakh",
        "Average_Package": "INR 10 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "APIM, New Delhi",
        "Courses_Offered": "MBA - Healthcare Mangement-RUDN University/PGDM",
        "Fees": "INR 11.50 Lakhs",
        "Average_Package": "INR 8.11 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Shoolini University, Solan",
        "Courses_Offered": "MBA",
        "Fees": "INR 7.5 Lakhs",
        "Average_Package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "VJIM, Hyderabad",
        "Courses_Offered": "PGDM",
        "Fees": "INR 8.6 Lakhs",
        "Average_Package": "INR 8.3 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Vishwa Vishwani Institute Of Management, Hyderabad",
        "Courses_Offered": "MBA / PGDM",
        "Fees": "INR 7.4 Lakhs",
        "Average_Package": "INR 6 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Prestige University, Indore",
        "Courses_Offered": "MBA",
        "Fees": "INR 11 Lakhs",
        "Average_Package": "INR 5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Globsyn Business School, Kolkata",
        "Courses_Offered": "PGDM, Global MBA ,",
        "Fees": "8.7 L",
        "Average_Package": "7.39 L",
        "percentile": "40"
    },
    {
        "College_Name": "St. Xavier Business School, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "INR 10.80 Lakh",
        "Average_Package": "7.5 L",
        "percentile": "40"
    },
    {
        "College_Name": "Praxis Business School, Kolkata",
        "Courses_Offered": "PGDM, PGPDS",
        "Fees": "INR 11.30 Lakh",
        "Average_Package": "8 L",
        "percentile": "40"
    },
    {
        "College_Name": "SVIMCS, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "INR 5.20 Lakh",
        "Average_Package": "5 - 6 L",
        "percentile": "40"
    },
    {
        "College_Name": "Adamas University, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "INR 6.37 Lakh",
        "Average_Package": "4.5 L",
        "percentile": "40"
    },
    {
        "College_Name": "IQ City United World School of Business, Kolkata",
        "Courses_Offered": "MBA+PGP",
        "Fees": "INR 7.20 Lakh",
        "Average_Package": "6 L",
        "percentile": "40"
    },
    {
        "College_Name": "Institute of Management Study, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "MBA - 5.75 Lakh\n MBA (Blended) - 3.75 Lakh",
        "Average_Package": "2.40 L",
        "percentile": "40"
    },
    {
        "College_Name": "BIBS, Kolkata",
        "Courses_Offered": "MBA+PGP",
        "Fees": "MBA - 6.88 Lakh\n MBA (Data Analytics) - 7.38 Lakh\n Executive MBA - 4.2 Lakh",
        "Average_Package": "6 L",
        "percentile": "40"
    },
    {
        "College_Name": "IILM Acadmy of Higher Learning, Lucknow",
        "Courses_Offered": "PGDM",
        "Fees": "6.90 L",
        "Average_Package": "6 L",
        "percentile": "40"
    },
    {
        "College_Name": "JSKBS, Mumbai",
        "Courses_Offered": "PGDM",
        "Fees": "6.75 L",
        "Average_Package": "6.5 L",
        "percentile": "40"
    },
    {
        "College_Name": "Institute for Technology and Management, Navi Mumbai",
        "Courses_Offered": "MBA",
        "Fees": "INR 12.45 Lakh",
        "Average_Package": "INR 8.65 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Amity University, Mumbai",
        "Courses_Offered": "MBA",
        "Fees": "INR 4.96-6.52 Lakhs",
        "Average_Package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "UKS, Mumbai",
        "Courses_Offered": "PGDM",
        "Fees": "INR 6 - 6.50 Lakhs",
        "Average_Package": "INR 5.75 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "ADYPU, Lohegaon Pune",
        "Courses_Offered": "MBA",
        "Fees": "INR 7 Lakhs",
        "Average_Package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Sandip University, Nasik",
        "Courses_Offered": "MBA",
        "Fees": "MBA- 2.60 Lakhs\n New Age MBA- 4.90 Lakhs",
        "Average_Package": "INR 4.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "MILE, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "INR 10.50 Lakhs",
        "Average_Package": "INR 8.27 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "MIMA, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "PGDM - 7.65 Lakh\n PGDM (Agri. & Pharma) - 6.70 Lakh",
        "Average_Package": "INR 7.50 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Pune Business School, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "INR 5.90 Lakhs",
        "Average_Package": "INR 6.8 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "PCU, Pune",
        "Courses_Offered": "MBA",
        "Fees": "INR 5 Lakhs",
        "Average_Package": "INR 5.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Suryadatta Institute of Business Management, Pune",
        "Courses_Offered": "MBA",
        "Fees": "INR 5 Lakhs",
        "Average_Package": "INR 6.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "KIAMS, Pune",
        "Courses_Offered": "PGDM",
        "Fees": "INR 12.60 Lakhs including lodging",
        "Average_Package": "INR 8.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "KCM, Banglore",
        "Courses_Offered": "MBA",
        "Fees": "INR 6.95 Lakh",
        "Average_Package": "INR 7.2 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "SOIL Institute of Management, Gurugram",
        "Courses_Offered": "PGDM",
        "Fees": "INR 15.80 Lakh",
        "Average_Package": "10.3 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "MIMT",
        "Courses_Offered": "MBA & MBA++",
        "Fees": "INR MBA 3.09 Lakh & MBA++ 5.25 Lakh",
        "Average_Package": "5.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "DIT University, Dehradun",
        "Courses_Offered": "MBA",
        "Fees": "5.5 Approx",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "G D Goenka University",
        "Courses_Offered": "MBA",
        "Fees": "MBA - 8.50 Lakh\n MBA in Fin. - 9 Lakh\n MBA in BA - 10.50 Lakh",
        "Average_Package": "7 Lakh",
        "percentile": "40"
    },
    {
        "College_Name": "IEM, Kolkata",
        "Courses_Offered": "MBA",
        "Fees": "MBA - 8 Lakh",
        "Average_Package": "14 Lakh",
        "percentile": "40"
    },
    {
        "College_Name": "RIT",
        "Courses_Offered": "MBA",
        "Fees": "₹1,75,000 per year",
        "Average_Package": "7 lakh",
        "percentile": "40"
    },
    {
        "College_Name": "Chanakya University",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "IBI B School",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "IMM - Institute of Marketing & Management",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "Sparsh Global Business School",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "Quantum University",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "Karnavati University",
        "Courses_Offered": "",
        "Fees": "",
        "Average_Package": "",
        "percentile": "40"
    },
    {
        "College_Name": "Accurate B School",
        "Courses_Offered": "MBA",
        "Fees": "3 LAKHS",
        "Average_Package": "4.5 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "AIMS B School Pune",
        "Courses_Offered": "mba",
        "Fees": "3.9 lakhs",
        "Average_Package": "5.35 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "St. Wilfred’s College of Management Studies",
        "Courses_Offered": "PGDM",
        "Fees": "INR 7.9 Lakh",
        "Average_Package": "4 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "Ganpat University",
        "Courses_Offered": "MBA",
        "Fees": "2.25 & 2.60 Lakh",
        "Average_Package": "4.05 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "St Kabir institute of Professional studies",
        "Courses_Offered": "PGDM",
        "Fees": "6.25 lakhs",
        "Average_Package": "5.5 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "Silver Oak University",
        "Courses_Offered": "mba",
        "Fees": "3 lakhs",
        "Average_Package": "10 LPA",
        "percentile": "40"
    },
    {
        "College_Name": "Parul University",
        "Courses_Offered": "MBA",
        "Fees": "3.84 LAKHS",
        "Average_Package": "3.6. LPA",
        "percentile": "40"
    },
    {
        "College_Name": "FMS Jaipur (IIRM Jaipur Campus)",
        "Courses_Offered": "PGDM",
        "Fees": "8 lakhs",
        "Average_Package": "7 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "Narayana Business School",
        "Courses_Offered": "PGDM",
        "Fees": "9.85 lakhs",
        "Average_Package": "8.4 lpa",
        "percentile": "40"
    },
    {
        "College_Name": "Scaler",
        "Courses_Offered": "PGP - MT",
        "Fees": "21 Lakhs",
        "Average_Package": "24 LPA",
        "percentile": "40"
    }
]

}
